var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/.deno/fetch-retry@6.0.0/node_modules/fetch-retry/dist/fetch-retry.umd.js
var require_fetch_retry_umd = __commonJS({
  "node_modules/.deno/fetch-retry@6.0.0/node_modules/fetch-retry/dist/fetch-retry.umd.js"(exports, module) {
    (function(global, factory) {
      typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, global.fetchRetry = factory());
    })(exports, function() {
      "use strict";
      var fetchRetry2 = function(fetch2, defaults) {
        defaults = defaults || {};
        if (typeof fetch2 !== "function") {
          throw new ArgumentError("fetch must be a function");
        }
        if (typeof defaults !== "object") {
          throw new ArgumentError("defaults must be an object");
        }
        if (defaults.retries !== void 0 && !isPositiveInteger(defaults.retries)) {
          throw new ArgumentError("retries must be a positive integer");
        }
        if (defaults.retryDelay !== void 0 && !isPositiveInteger(defaults.retryDelay) && typeof defaults.retryDelay !== "function") {
          throw new ArgumentError("retryDelay must be a positive integer or a function returning a positive integer");
        }
        if (defaults.retryOn !== void 0 && !Array.isArray(defaults.retryOn) && typeof defaults.retryOn !== "function") {
          throw new ArgumentError("retryOn property expects an array or function");
        }
        var baseDefaults = {
          retries: 3,
          retryDelay: 1e3,
          retryOn: []
        };
        defaults = Object.assign(baseDefaults, defaults);
        return function fetchRetry3(input, init) {
          var retries = defaults.retries;
          var retryDelay = defaults.retryDelay;
          var retryOn = defaults.retryOn;
          if (init && init.retries !== void 0) {
            if (isPositiveInteger(init.retries)) {
              retries = init.retries;
            } else {
              throw new ArgumentError("retries must be a positive integer");
            }
          }
          if (init && init.retryDelay !== void 0) {
            if (isPositiveInteger(init.retryDelay) || typeof init.retryDelay === "function") {
              retryDelay = init.retryDelay;
            } else {
              throw new ArgumentError("retryDelay must be a positive integer or a function returning a positive integer");
            }
          }
          if (init && init.retryOn) {
            if (Array.isArray(init.retryOn) || typeof init.retryOn === "function") {
              retryOn = init.retryOn;
            } else {
              throw new ArgumentError("retryOn property expects an array or function");
            }
          }
          return new Promise(function(resolve, reject) {
            var wrappedFetch = function(attempt) {
              var _input = typeof Request !== "undefined" && input instanceof Request ? input.clone() : input;
              fetch2(_input, init).then(function(response) {
                if (Array.isArray(retryOn) && retryOn.indexOf(response.status) === -1) {
                  resolve(response);
                } else if (typeof retryOn === "function") {
                  try {
                    return Promise.resolve(retryOn(attempt, null, response)).then(function(retryOnResponse) {
                      if (retryOnResponse) {
                        retry(attempt, null, response);
                      } else {
                        resolve(response);
                      }
                    }).catch(reject);
                  } catch (error) {
                    reject(error);
                  }
                } else {
                  if (attempt < retries) {
                    retry(attempt, null, response);
                  } else {
                    resolve(response);
                  }
                }
              }).catch(function(error) {
                if (typeof retryOn === "function") {
                  try {
                    Promise.resolve(retryOn(attempt, error, null)).then(function(retryOnResponse) {
                      if (retryOnResponse) {
                        retry(attempt, error, null);
                      } else {
                        reject(error);
                      }
                    }).catch(function(error2) {
                      reject(error2);
                    });
                  } catch (error2) {
                    reject(error2);
                  }
                } else if (attempt < retries) {
                  retry(attempt, error, null);
                } else {
                  reject(error);
                }
              });
            };
            function retry(attempt, error, response) {
              var delay = typeof retryDelay === "function" ? retryDelay(attempt, error, response) : retryDelay;
              setTimeout(function() {
                wrappedFetch(++attempt);
              }, delay);
            }
            wrappedFetch(0);
          });
        };
      };
      function isPositiveInteger(value) {
        return Number.isInteger(value) && value >= 0;
      }
      function ArgumentError(message) {
        this.name = "ArgumentError";
        this.message = message;
      }
      return fetchRetry2;
    });
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/utils/comparators.js
var require_comparators = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/utils/comparators.js"(exports) {
    var DEFAULT_COMPARATOR = function(a, b) {
      if (a < b)
        return -1;
      if (a > b)
        return 1;
      return 0;
    };
    var DEFAULT_REVERSE_COMPARATOR = function(a, b) {
      if (a < b)
        return 1;
      if (a > b)
        return -1;
      return 0;
    };
    function reverseComparator(comparator) {
      return function(a, b) {
        return comparator(b, a);
      };
    }
    function createTupleComparator(size) {
      if (size === 2) {
        return function(a, b) {
          if (a[0] < b[0])
            return -1;
          if (a[0] > b[0])
            return 1;
          if (a[1] < b[1])
            return -1;
          if (a[1] > b[1])
            return 1;
          return 0;
        };
      }
      return function(a, b) {
        var i = 0;
        while (i < size) {
          if (a[i] < b[i])
            return -1;
          if (a[i] > b[i])
            return 1;
          i++;
        }
        return 0;
      };
    }
    exports.DEFAULT_COMPARATOR = DEFAULT_COMPARATOR;
    exports.DEFAULT_REVERSE_COMPARATOR = DEFAULT_REVERSE_COMPARATOR;
    exports.reverseComparator = reverseComparator;
    exports.createTupleComparator = createTupleComparator;
  }
});

// node_modules/.deno/obliterator@2.0.5/node_modules/obliterator/support.js
var require_support = __commonJS({
  "node_modules/.deno/obliterator@2.0.5/node_modules/obliterator/support.js"(exports) {
    exports.ARRAY_BUFFER_SUPPORT = typeof ArrayBuffer !== "undefined";
    exports.SYMBOL_SUPPORT = typeof Symbol !== "undefined";
  }
});

// node_modules/.deno/obliterator@2.0.5/node_modules/obliterator/foreach.js
var require_foreach = __commonJS({
  "node_modules/.deno/obliterator@2.0.5/node_modules/obliterator/foreach.js"(exports, module) {
    var support = require_support();
    var ARRAY_BUFFER_SUPPORT = support.ARRAY_BUFFER_SUPPORT;
    var SYMBOL_SUPPORT = support.SYMBOL_SUPPORT;
    module.exports = function forEach(iterable, callback) {
      var iterator, k, i, l, s;
      if (!iterable) throw new Error("obliterator/forEach: invalid iterable.");
      if (typeof callback !== "function")
        throw new Error("obliterator/forEach: expecting a callback.");
      if (Array.isArray(iterable) || ARRAY_BUFFER_SUPPORT && ArrayBuffer.isView(iterable) || typeof iterable === "string" || iterable.toString() === "[object Arguments]") {
        for (i = 0, l = iterable.length; i < l; i++) callback(iterable[i], i);
        return;
      }
      if (typeof iterable.forEach === "function") {
        iterable.forEach(callback);
        return;
      }
      if (SYMBOL_SUPPORT && Symbol.iterator in iterable && typeof iterable.next !== "function") {
        iterable = iterable[Symbol.iterator]();
      }
      if (typeof iterable.next === "function") {
        iterator = iterable;
        i = 0;
        while (s = iterator.next(), s.done !== true) {
          callback(s.value, i);
          i++;
        }
        return;
      }
      for (k in iterable) {
        if (iterable.hasOwnProperty(k)) {
          callback(iterable[k], k);
        }
      }
      return;
    };
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/fibonacci-heap.js
var require_fibonacci_heap = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/fibonacci-heap.js"(exports, module) {
    var comparators = require_comparators();
    var forEach = require_foreach();
    var DEFAULT_COMPARATOR = comparators.DEFAULT_COMPARATOR;
    var reverseComparator = comparators.reverseComparator;
    function FibonacciHeap2(comparator) {
      this.clear();
      this.comparator = comparator || DEFAULT_COMPARATOR;
      if (typeof this.comparator !== "function")
        throw new Error("mnemonist/FibonacciHeap.constructor: given comparator should be a function.");
    }
    FibonacciHeap2.prototype.clear = function() {
      this.root = null;
      this.min = null;
      this.size = 0;
    };
    function createNode(item) {
      return {
        item,
        degree: 0
      };
    }
    function mergeWithRoot(heap, node) {
      if (!heap.root) {
        heap.root = node;
      } else {
        node.right = heap.root.right;
        node.left = heap.root;
        heap.root.right.left = node;
        heap.root.right = node;
      }
    }
    FibonacciHeap2.prototype.push = function(item) {
      var node = createNode(item);
      node.left = node;
      node.right = node;
      mergeWithRoot(this, node);
      if (!this.min || this.comparator(node.item, this.min.item) <= 0)
        this.min = node;
      return ++this.size;
    };
    FibonacciHeap2.prototype.peek = function() {
      return this.min ? this.min.item : void 0;
    };
    function consumeLinkedList(head) {
      var nodes = [], node = head, flag = false;
      while (true) {
        if (node === head && flag)
          break;
        else if (node === head)
          flag = true;
        nodes.push(node);
        node = node.right;
      }
      return nodes;
    }
    function removeFromRoot(heap, node) {
      if (heap.root === node)
        heap.root = node.right;
      node.left.right = node.right;
      node.right.left = node.left;
    }
    function mergeWithChild(parent, node) {
      if (!parent.child) {
        parent.child = node;
      } else {
        node.right = parent.child.right;
        node.left = parent.child;
        parent.child.right.left = node;
        parent.child.right = node;
      }
    }
    function link(heap, y, x) {
      removeFromRoot(heap, y);
      y.left = y;
      y.right = y;
      mergeWithChild(x, y);
      x.degree++;
      y.parent = x;
    }
    function consolidate(heap) {
      var A = new Array(heap.size), nodes = consumeLinkedList(heap.root), i, l, x, y, d, t;
      for (i = 0, l = nodes.length; i < l; i++) {
        x = nodes[i];
        d = x.degree;
        while (A[d]) {
          y = A[d];
          if (heap.comparator(x.item, y.item) > 0) {
            t = x;
            x = y;
            y = t;
          }
          link(heap, y, x);
          A[d] = null;
          d++;
        }
        A[d] = x;
      }
      for (i = 0; i < heap.size; i++) {
        if (A[i] && heap.comparator(A[i].item, heap.min.item) <= 0)
          heap.min = A[i];
      }
    }
    FibonacciHeap2.prototype.pop = function() {
      if (!this.size)
        return void 0;
      var z = this.min;
      if (z.child) {
        var nodes = consumeLinkedList(z.child), node, i, l;
        for (i = 0, l = nodes.length; i < l; i++) {
          node = nodes[i];
          mergeWithRoot(this, node);
          delete node.parent;
        }
      }
      removeFromRoot(this, z);
      if (z === z.right) {
        this.min = null;
        this.root = null;
      } else {
        this.min = z.right;
        consolidate(this);
      }
      this.size--;
      return z.item;
    };
    FibonacciHeap2.prototype.inspect = function() {
      var proxy = {
        size: this.size
      };
      if (this.min && "item" in this.min)
        proxy.top = this.min.item;
      Object.defineProperty(proxy, "constructor", {
        value: FibonacciHeap2,
        enumerable: false
      });
      return proxy;
    };
    if (typeof Symbol !== "undefined")
      FibonacciHeap2.prototype[Symbol.for("nodejs.util.inspect.custom")] = FibonacciHeap2.prototype.inspect;
    function MaxFibonacciHeap2(comparator) {
      this.clear();
      this.comparator = comparator || DEFAULT_COMPARATOR;
      if (typeof this.comparator !== "function")
        throw new Error("mnemonist/FibonacciHeap.constructor: given comparator should be a function.");
      this.comparator = reverseComparator(this.comparator);
    }
    MaxFibonacciHeap2.prototype = FibonacciHeap2.prototype;
    FibonacciHeap2.from = function(iterable, comparator) {
      var heap = new FibonacciHeap2(comparator);
      forEach(iterable, function(value) {
        heap.push(value);
      });
      return heap;
    };
    MaxFibonacciHeap2.from = function(iterable, comparator) {
      var heap = new MaxFibonacciHeap2(comparator);
      forEach(iterable, function(value) {
        heap.push(value);
      });
      return heap;
    };
    FibonacciHeap2.MinFibonacciHeap = FibonacciHeap2;
    FibonacciHeap2.MaxFibonacciHeap = MaxFibonacciHeap2;
    module.exports = FibonacciHeap2;
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/utils/typed-arrays.js
var require_typed_arrays = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/utils/typed-arrays.js"(exports) {
    var MAX_8BIT_INTEGER = Math.pow(2, 8) - 1;
    var MAX_16BIT_INTEGER = Math.pow(2, 16) - 1;
    var MAX_32BIT_INTEGER = Math.pow(2, 32) - 1;
    var MAX_SIGNED_8BIT_INTEGER = Math.pow(2, 7) - 1;
    var MAX_SIGNED_16BIT_INTEGER = Math.pow(2, 15) - 1;
    var MAX_SIGNED_32BIT_INTEGER = Math.pow(2, 31) - 1;
    exports.getPointerArray = function(size) {
      var maxIndex = size - 1;
      if (maxIndex <= MAX_8BIT_INTEGER)
        return Uint8Array;
      if (maxIndex <= MAX_16BIT_INTEGER)
        return Uint16Array;
      if (maxIndex <= MAX_32BIT_INTEGER)
        return Uint32Array;
      throw new Error("mnemonist: Pointer Array of size > 4294967295 is not supported.");
    };
    exports.getSignedPointerArray = function(size) {
      var maxIndex = size - 1;
      if (maxIndex <= MAX_SIGNED_8BIT_INTEGER)
        return Int8Array;
      if (maxIndex <= MAX_SIGNED_16BIT_INTEGER)
        return Int16Array;
      if (maxIndex <= MAX_SIGNED_32BIT_INTEGER)
        return Int32Array;
      return Float64Array;
    };
    exports.getNumberType = function(value) {
      if (value === (value | 0)) {
        if (Math.sign(value) === -1) {
          if (value <= 127 && value >= -128)
            return Int8Array;
          if (value <= 32767 && value >= -32768)
            return Int16Array;
          return Int32Array;
        } else {
          if (value <= 255)
            return Uint8Array;
          if (value <= 65535)
            return Uint16Array;
          return Uint32Array;
        }
      }
      return Float64Array;
    };
    var TYPE_PRIORITY = {
      Uint8Array: 1,
      Int8Array: 2,
      Uint16Array: 3,
      Int16Array: 4,
      Uint32Array: 5,
      Int32Array: 6,
      Float32Array: 7,
      Float64Array: 8
    };
    exports.getMinimalRepresentation = function(array, getter) {
      var maxType = null, maxPriority = 0, p, t, v, i, l;
      for (i = 0, l = array.length; i < l; i++) {
        v = getter ? getter(array[i]) : array[i];
        t = exports.getNumberType(v);
        p = TYPE_PRIORITY[t.name];
        if (p > maxPriority) {
          maxPriority = p;
          maxType = t;
        }
      }
      return maxType;
    };
    exports.isTypedArray = function(value) {
      return typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView(value);
    };
    exports.concat = function() {
      var length = 0, i, o, l;
      for (i = 0, l = arguments.length; i < l; i++)
        length += arguments[i].length;
      var array = new arguments[0].constructor(length);
      for (i = 0, o = 0; i < l; i++) {
        array.set(arguments[i], o);
        o += arguments[i].length;
      }
      return array;
    };
    exports.indices = function(length) {
      var PointerArray = exports.getPointerArray(length);
      var array = new PointerArray(length);
      for (var i = 0; i < length; i++)
        array[i] = i;
      return array;
    };
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/utils/iterables.js
var require_iterables = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/utils/iterables.js"(exports) {
    var forEach = require_foreach();
    var typed = require_typed_arrays();
    function isArrayLike(target) {
      return Array.isArray(target) || typed.isTypedArray(target);
    }
    function guessLength(target) {
      if (typeof target.length === "number")
        return target.length;
      if (typeof target.size === "number")
        return target.size;
      return;
    }
    function toArray(target) {
      var l = guessLength(target);
      var array = typeof l === "number" ? new Array(l) : [];
      var i = 0;
      forEach(target, function(value) {
        array[i++] = value;
      });
      return array;
    }
    function toArrayWithIndices(target) {
      var l = guessLength(target);
      var IndexArray = typeof l === "number" ? typed.getPointerArray(l) : Array;
      var array = typeof l === "number" ? new Array(l) : [];
      var indices = typeof l === "number" ? new IndexArray(l) : [];
      var i = 0;
      forEach(target, function(value) {
        array[i] = value;
        indices[i] = i++;
      });
      return [array, indices];
    }
    exports.isArrayLike = isArrayLike;
    exports.guessLength = guessLength;
    exports.toArray = toArray;
    exports.toArrayWithIndices = toArrayWithIndices;
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/heap.js
var require_heap = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/heap.js"(exports, module) {
    var forEach = require_foreach();
    var comparators = require_comparators();
    var iterables = require_iterables();
    var DEFAULT_COMPARATOR = comparators.DEFAULT_COMPARATOR;
    var reverseComparator = comparators.reverseComparator;
    function siftDown(compare, heap, startIndex, i) {
      var item = heap[i], parentIndex, parent;
      while (i > startIndex) {
        parentIndex = i - 1 >> 1;
        parent = heap[parentIndex];
        if (compare(item, parent) < 0) {
          heap[i] = parent;
          i = parentIndex;
          continue;
        }
        break;
      }
      heap[i] = item;
    }
    function siftUp(compare, heap, i) {
      var endIndex = heap.length, startIndex = i, item = heap[i], childIndex = 2 * i + 1, rightIndex;
      while (childIndex < endIndex) {
        rightIndex = childIndex + 1;
        if (rightIndex < endIndex && compare(heap[childIndex], heap[rightIndex]) >= 0) {
          childIndex = rightIndex;
        }
        heap[i] = heap[childIndex];
        i = childIndex;
        childIndex = 2 * i + 1;
      }
      heap[i] = item;
      siftDown(compare, heap, startIndex, i);
    }
    function push(compare, heap, item) {
      heap.push(item);
      siftDown(compare, heap, 0, heap.length - 1);
    }
    function pop(compare, heap) {
      var lastItem = heap.pop();
      if (heap.length !== 0) {
        var item = heap[0];
        heap[0] = lastItem;
        siftUp(compare, heap, 0);
        return item;
      }
      return lastItem;
    }
    function replace(compare, heap, item) {
      if (heap.length === 0)
        throw new Error("mnemonist/heap.replace: cannot pop an empty heap.");
      var popped = heap[0];
      heap[0] = item;
      siftUp(compare, heap, 0);
      return popped;
    }
    function pushpop(compare, heap, item) {
      var tmp;
      if (heap.length !== 0 && compare(heap[0], item) < 0) {
        tmp = heap[0];
        heap[0] = item;
        item = tmp;
        siftUp(compare, heap, 0);
      }
      return item;
    }
    function heapify(compare, array) {
      var n = array.length, l = n >> 1, i = l;
      while (--i >= 0)
        siftUp(compare, array, i);
    }
    function consume(compare, heap) {
      var l = heap.length, i = 0;
      var array = new Array(l);
      while (i < l)
        array[i++] = pop(compare, heap);
      return array;
    }
    function nsmallest(compare, n, iterable) {
      if (arguments.length === 2) {
        iterable = n;
        n = compare;
        compare = DEFAULT_COMPARATOR;
      }
      var reverseCompare = reverseComparator(compare);
      var i, l, v;
      var min = Infinity;
      var result;
      if (n === 1) {
        if (iterables.isArrayLike(iterable)) {
          for (i = 0, l = iterable.length; i < l; i++) {
            v = iterable[i];
            if (min === Infinity || compare(v, min) < 0)
              min = v;
          }
          result = new iterable.constructor(1);
          result[0] = min;
          return result;
        }
        forEach(iterable, function(value) {
          if (min === Infinity || compare(value, min) < 0)
            min = value;
        });
        return [min];
      }
      if (iterables.isArrayLike(iterable)) {
        if (n >= iterable.length)
          return iterable.slice().sort(compare);
        result = iterable.slice(0, n);
        heapify(reverseCompare, result);
        for (i = n, l = iterable.length; i < l; i++)
          if (reverseCompare(iterable[i], result[0]) > 0)
            replace(reverseCompare, result, iterable[i]);
        return result.sort(compare);
      }
      var size = iterables.guessLength(iterable);
      if (size !== null && size < n)
        n = size;
      result = new Array(n);
      i = 0;
      forEach(iterable, function(value) {
        if (i < n) {
          result[i] = value;
        } else {
          if (i === n)
            heapify(reverseCompare, result);
          if (reverseCompare(value, result[0]) > 0)
            replace(reverseCompare, result, value);
        }
        i++;
      });
      if (result.length > i)
        result.length = i;
      return result.sort(compare);
    }
    function nlargest(compare, n, iterable) {
      if (arguments.length === 2) {
        iterable = n;
        n = compare;
        compare = DEFAULT_COMPARATOR;
      }
      var reverseCompare = reverseComparator(compare);
      var i, l, v;
      var max = -Infinity;
      var result;
      if (n === 1) {
        if (iterables.isArrayLike(iterable)) {
          for (i = 0, l = iterable.length; i < l; i++) {
            v = iterable[i];
            if (max === -Infinity || compare(v, max) > 0)
              max = v;
          }
          result = new iterable.constructor(1);
          result[0] = max;
          return result;
        }
        forEach(iterable, function(value) {
          if (max === -Infinity || compare(value, max) > 0)
            max = value;
        });
        return [max];
      }
      if (iterables.isArrayLike(iterable)) {
        if (n >= iterable.length)
          return iterable.slice().sort(reverseCompare);
        result = iterable.slice(0, n);
        heapify(compare, result);
        for (i = n, l = iterable.length; i < l; i++)
          if (compare(iterable[i], result[0]) > 0)
            replace(compare, result, iterable[i]);
        return result.sort(reverseCompare);
      }
      var size = iterables.guessLength(iterable);
      if (size !== null && size < n)
        n = size;
      result = new Array(n);
      i = 0;
      forEach(iterable, function(value) {
        if (i < n) {
          result[i] = value;
        } else {
          if (i === n)
            heapify(compare, result);
          if (compare(value, result[0]) > 0)
            replace(compare, result, value);
        }
        i++;
      });
      if (result.length > i)
        result.length = i;
      return result.sort(reverseCompare);
    }
    function Heap2(comparator) {
      this.clear();
      this.comparator = comparator || DEFAULT_COMPARATOR;
      if (typeof this.comparator !== "function")
        throw new Error("mnemonist/Heap.constructor: given comparator should be a function.");
    }
    Heap2.prototype.clear = function() {
      this.items = [];
      this.size = 0;
    };
    Heap2.prototype.push = function(item) {
      push(this.comparator, this.items, item);
      return ++this.size;
    };
    Heap2.prototype.peek = function() {
      return this.items[0];
    };
    Heap2.prototype.pop = function() {
      if (this.size !== 0)
        this.size--;
      return pop(this.comparator, this.items);
    };
    Heap2.prototype.replace = function(item) {
      return replace(this.comparator, this.items, item);
    };
    Heap2.prototype.pushpop = function(item) {
      return pushpop(this.comparator, this.items, item);
    };
    Heap2.prototype.consume = function() {
      this.size = 0;
      return consume(this.comparator, this.items);
    };
    Heap2.prototype.toArray = function() {
      return consume(this.comparator, this.items.slice());
    };
    Heap2.prototype.inspect = function() {
      var proxy = this.toArray();
      Object.defineProperty(proxy, "constructor", {
        value: Heap2,
        enumerable: false
      });
      return proxy;
    };
    if (typeof Symbol !== "undefined")
      Heap2.prototype[Symbol.for("nodejs.util.inspect.custom")] = Heap2.prototype.inspect;
    function MaxHeap2(comparator) {
      this.clear();
      this.comparator = comparator || DEFAULT_COMPARATOR;
      if (typeof this.comparator !== "function")
        throw new Error("mnemonist/MaxHeap.constructor: given comparator should be a function.");
      this.comparator = reverseComparator(this.comparator);
    }
    MaxHeap2.prototype = Heap2.prototype;
    Heap2.from = function(iterable, comparator) {
      var heap = new Heap2(comparator);
      var items;
      if (iterables.isArrayLike(iterable))
        items = iterable.slice();
      else
        items = iterables.toArray(iterable);
      heapify(heap.comparator, items);
      heap.items = items;
      heap.size = items.length;
      return heap;
    };
    MaxHeap2.from = function(iterable, comparator) {
      var heap = new MaxHeap2(comparator);
      var items;
      if (iterables.isArrayLike(iterable))
        items = iterable.slice();
      else
        items = iterables.toArray(iterable);
      heapify(heap.comparator, items);
      heap.items = items;
      heap.size = items.length;
      return heap;
    };
    Heap2.siftUp = siftUp;
    Heap2.siftDown = siftDown;
    Heap2.push = push;
    Heap2.pop = pop;
    Heap2.replace = replace;
    Heap2.pushpop = pushpop;
    Heap2.heapify = heapify;
    Heap2.consume = consume;
    Heap2.nsmallest = nsmallest;
    Heap2.nlargest = nlargest;
    Heap2.MinHeap = Heap2;
    Heap2.MaxHeap = MaxHeap2;
    module.exports = Heap2;
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/suffix-array.js
var require_suffix_array = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/suffix-array.js"(exports, module) {
    var SEPARATOR = "";
    function sort(string, array, offset) {
      var l = array.length, buckets = [], i = l, j = -1, b, d = 0, bits;
      while (i--)
        j = Math.max(string[array[i] + offset], j);
      bits = j >> 24 && 32 || j >> 16 && 24 || j >> 8 && 16 || 8;
      for (; d < bits; d += 4) {
        for (i = 16; i--; )
          buckets[i] = [];
        for (i = l; i--; )
          buckets[string[array[i] + offset] >> d & 15].push(array[i]);
        for (b = 0; b < 16; b++) {
          for (j = buckets[b].length; j--; )
            array[++i] = buckets[b][j];
        }
      }
    }
    function compare(string, lookup, m, n) {
      return string[m] - string[n] || (m % 3 === 2 ? string[m + 1] - string[n + 1] || lookup[m + 2] - lookup[n + 2] : lookup[m + 1] - lookup[n + 1]);
    }
    function build(string, l) {
      var a = [], b = [], al = 2 * l / 3 | 0, bl = l - al, r = al + 1 >> 1, i = al, j = 0, k, lookup = [], result = [];
      if (l === 1)
        return [0];
      while (i--)
        a[i] = (i * 3 >> 1) + 1;
      for (i = 3; i--; )
        sort(string, a, i);
      j = b[(a[0] / 3 | 0) + (a[0] % 3 === 1 ? 0 : r)] = 1;
      for (i = 1; i < al; i++) {
        if (string[a[i]] !== string[a[i - 1]] || string[a[i] + 1] !== string[a[i - 1] + 1] || string[a[i] + 2] !== string[a[i - 1] + 2])
          j++;
        b[(a[i] / 3 | 0) + (a[i] % 3 === 1 ? 0 : r)] = j;
      }
      if (j < al) {
        b = build(b, al);
        for (i = al; i--; )
          a[i] = b[i] < r ? b[i] * 3 + 1 : (b[i] - r) * 3 + 2;
      }
      for (i = al; i--; )
        lookup[a[i]] = i;
      lookup[l] = -1;
      lookup[l + 1] = -2;
      b = l % 3 === 1 ? [l - 1] : [];
      for (i = 0; i < al; i++) {
        if (a[i] % 3 === 1)
          b.push(a[i] - 1);
      }
      sort(string, b, 0);
      for (i = 0, j = 0, k = 0; i < al && j < bl; )
        result[k++] = compare(string, lookup, a[i], b[j]) < 0 ? a[i++] : b[j++];
      while (i < al)
        result[k++] = a[i++];
      while (j < bl)
        result[k++] = b[j++];
      return result;
    }
    function convert(target) {
      var length = target.length, paddingOffset = length % 3, array = new Array(length + paddingOffset), l, i;
      if (typeof target !== "string") {
        var uniqueTokens = /* @__PURE__ */ Object.create(null);
        for (i = 0; i < length; i++) {
          if (!uniqueTokens[target[i]])
            uniqueTokens[target[i]] = true;
        }
        var alphabet = /* @__PURE__ */ Object.create(null), sortedUniqueTokens = Object.keys(uniqueTokens).sort();
        for (i = 0, l = sortedUniqueTokens.length; i < l; i++)
          alphabet[sortedUniqueTokens[i]] = i + 1;
        for (i = 0; i < length; i++) {
          array[i] = alphabet[target[i]];
        }
      } else {
        for (i = 0; i < length; i++)
          array[i] = target.charCodeAt(i);
      }
      for (i = length; i < length + paddingOffset; i++)
        array[i] = 0;
      return array;
    }
    function SuffixArray2(string) {
      this.hasArbitrarySequence = typeof string !== "string";
      this.string = string;
      this.length = string.length;
      this.array = build(convert(string), this.length);
    }
    SuffixArray2.prototype.toString = function() {
      return this.array.join(",");
    };
    SuffixArray2.prototype.toJSON = function() {
      return this.array;
    };
    SuffixArray2.prototype.inspect = function() {
      var array = new Array(this.length);
      for (var i = 0; i < this.length; i++)
        array[i] = this.string.slice(this.array[i]);
      Object.defineProperty(array, "constructor", {
        value: SuffixArray2,
        enumerable: false
      });
      return array;
    };
    if (typeof Symbol !== "undefined")
      SuffixArray2.prototype[Symbol.for("nodejs.util.inspect.custom")] = SuffixArray2.prototype.inspect;
    function GeneralizedSuffixArray2(strings) {
      this.hasArbitrarySequence = typeof strings[0] !== "string";
      this.size = strings.length;
      if (this.hasArbitrarySequence) {
        this.text = [];
        for (var i = 0, l = this.size; i < l; i++) {
          this.text.push.apply(this.text, strings[i]);
          if (i < l - 1)
            this.text.push(SEPARATOR);
        }
      } else {
        this.text = strings.join(SEPARATOR);
      }
      this.firstLength = strings[0].length;
      this.length = this.text.length;
      this.array = build(convert(this.text), this.length);
    }
    GeneralizedSuffixArray2.prototype.longestCommonSubsequence = function() {
      var lcs = this.hasArbitrarySequence ? [] : "", lcp, i, j, s, t;
      for (i = 1; i < this.length; i++) {
        s = this.array[i];
        t = this.array[i - 1];
        if (s < this.firstLength && t < this.firstLength)
          continue;
        if (s > this.firstLength && t > this.firstLength)
          continue;
        lcp = Math.min(this.length - s, this.length - t);
        for (j = 0; j < lcp; j++) {
          if (this.text[s + j] !== this.text[t + j]) {
            lcp = j;
            break;
          }
        }
        if (lcp > lcs.length)
          lcs = this.text.slice(s, s + lcp);
      }
      return lcs;
    };
    GeneralizedSuffixArray2.prototype.toString = function() {
      return this.array.join(",");
    };
    GeneralizedSuffixArray2.prototype.toJSON = function() {
      return this.array;
    };
    GeneralizedSuffixArray2.prototype.inspect = function() {
      var array = new Array(this.length);
      for (var i = 0; i < this.length; i++)
        array[i] = this.text.slice(this.array[i]);
      Object.defineProperty(array, "constructor", {
        value: GeneralizedSuffixArray2,
        enumerable: false
      });
      return array;
    };
    if (typeof Symbol !== "undefined")
      GeneralizedSuffixArray2.prototype[Symbol.for("nodejs.util.inspect.custom")] = GeneralizedSuffixArray2.prototype.inspect;
    SuffixArray2.GeneralizedSuffixArray = GeneralizedSuffixArray2;
    module.exports = SuffixArray2;
  }
});

// node_modules/.deno/obliterator@2.0.5/node_modules/obliterator/iterator.js
var require_iterator = __commonJS({
  "node_modules/.deno/obliterator@2.0.5/node_modules/obliterator/iterator.js"(exports, module) {
    function Iterator(next) {
      if (typeof next !== "function")
        throw new Error("obliterator/iterator: expecting a function!");
      this.next = next;
    }
    if (typeof Symbol !== "undefined")
      Iterator.prototype[Symbol.iterator] = function() {
        return this;
      };
    Iterator.of = function() {
      var args = arguments, l = args.length, i = 0;
      return new Iterator(function() {
        if (i >= l) return { done: true };
        return { done: false, value: args[i++] };
      });
    };
    Iterator.empty = function() {
      var iterator = new Iterator(function() {
        return { done: true };
      });
      return iterator;
    };
    Iterator.fromSequence = function(sequence) {
      var i = 0, l = sequence.length;
      return new Iterator(function() {
        if (i >= l) return { done: true };
        return { done: false, value: sequence[i++] };
      });
    };
    Iterator.is = function(value) {
      if (value instanceof Iterator) return true;
      return typeof value === "object" && value !== null && typeof value.next === "function";
    };
    module.exports = Iterator;
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/vector.js
var require_vector = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/vector.js"(exports, module) {
    var Iterator = require_iterator();
    var forEach = require_foreach();
    var iterables = require_iterables();
    var typed = require_typed_arrays();
    var DEFAULT_GROWING_POLICY = function(currentCapacity) {
      return Math.max(1, Math.ceil(currentCapacity * 1.5));
    };
    var pointerArrayFactory = function(capacity) {
      var PointerArray = typed.getPointerArray(capacity);
      return new PointerArray(capacity);
    };
    function Vector2(ArrayClass, initialCapacityOrOptions) {
      if (arguments.length < 1)
        throw new Error("mnemonist/vector: expecting at least a byte array constructor.");
      var initialCapacity = initialCapacityOrOptions || 0, policy = DEFAULT_GROWING_POLICY, initialLength = 0, factory = false;
      if (typeof initialCapacityOrOptions === "object") {
        initialCapacity = initialCapacityOrOptions.initialCapacity || 0;
        initialLength = initialCapacityOrOptions.initialLength || 0;
        policy = initialCapacityOrOptions.policy || policy;
        factory = initialCapacityOrOptions.factory === true;
      }
      this.factory = factory ? ArrayClass : null;
      this.ArrayClass = ArrayClass;
      this.length = initialLength;
      this.capacity = Math.max(initialLength, initialCapacity);
      this.policy = policy;
      this.array = new ArrayClass(this.capacity);
    }
    Vector2.prototype.set = function(index, value) {
      if (this.length < index)
        throw new Error("Vector(" + this.ArrayClass.name + ").set: index out of bounds.");
      this.array[index] = value;
      return this;
    };
    Vector2.prototype.get = function(index) {
      if (this.length < index)
        return void 0;
      return this.array[index];
    };
    Vector2.prototype.applyPolicy = function(override) {
      var newCapacity = this.policy(override || this.capacity);
      if (typeof newCapacity !== "number" || newCapacity < 0)
        throw new Error("mnemonist/vector.applyPolicy: policy returned an invalid value (expecting a positive integer).");
      if (newCapacity <= this.capacity)
        throw new Error("mnemonist/vector.applyPolicy: policy returned a less or equal capacity to allocate.");
      return newCapacity;
    };
    Vector2.prototype.reallocate = function(capacity) {
      if (capacity === this.capacity)
        return this;
      var oldArray = this.array;
      if (capacity < this.length)
        this.length = capacity;
      if (capacity > this.capacity) {
        if (this.factory === null)
          this.array = new this.ArrayClass(capacity);
        else
          this.array = this.factory(capacity);
        if (typed.isTypedArray(this.array)) {
          this.array.set(oldArray, 0);
        } else {
          for (var i = 0, l = this.length; i < l; i++)
            this.array[i] = oldArray[i];
        }
      } else {
        this.array = oldArray.slice(0, capacity);
      }
      this.capacity = capacity;
      return this;
    };
    Vector2.prototype.grow = function(capacity) {
      var newCapacity;
      if (typeof capacity === "number") {
        if (this.capacity >= capacity)
          return this;
        newCapacity = this.capacity;
        while (newCapacity < capacity)
          newCapacity = this.applyPolicy(newCapacity);
        this.reallocate(newCapacity);
        return this;
      }
      newCapacity = this.applyPolicy();
      this.reallocate(newCapacity);
      return this;
    };
    Vector2.prototype.resize = function(length) {
      if (length === this.length)
        return this;
      if (length < this.length) {
        this.length = length;
        return this;
      }
      this.length = length;
      this.reallocate(length);
      return this;
    };
    Vector2.prototype.push = function(value) {
      if (this.capacity === this.length)
        this.grow();
      this.array[this.length++] = value;
      return this.length;
    };
    Vector2.prototype.pop = function() {
      if (this.length === 0)
        return;
      return this.array[--this.length];
    };
    Vector2.prototype.values = function() {
      var items = this.array, l = this.length, i = 0;
      return new Iterator(function() {
        if (i >= l)
          return {
            done: true
          };
        var value = items[i];
        i++;
        return {
          value,
          done: false
        };
      });
    };
    Vector2.prototype.entries = function() {
      var items = this.array, l = this.length, i = 0;
      return new Iterator(function() {
        if (i >= l)
          return {
            done: true
          };
        var value = items[i];
        return {
          value: [i++, value],
          done: false
        };
      });
    };
    if (typeof Symbol !== "undefined")
      Vector2.prototype[Symbol.iterator] = Vector2.prototype.values;
    Vector2.prototype.inspect = function() {
      var proxy = this.array.slice(0, this.length);
      proxy.type = this.array.constructor.name;
      proxy.items = this.length;
      proxy.capacity = this.capacity;
      Object.defineProperty(proxy, "constructor", {
        value: Vector2,
        enumerable: false
      });
      return proxy;
    };
    if (typeof Symbol !== "undefined")
      Vector2.prototype[Symbol.for("nodejs.util.inspect.custom")] = Vector2.prototype.inspect;
    Vector2.from = function(iterable, ArrayClass, capacity) {
      if (arguments.length < 3) {
        capacity = iterables.guessLength(iterable);
        if (typeof capacity !== "number")
          throw new Error("mnemonist/vector.from: could not guess iterable length. Please provide desired capacity as last argument.");
      }
      var vector = new Vector2(ArrayClass, capacity);
      forEach(iterable, function(value) {
        vector.push(value);
      });
      return vector;
    };
    function subClass(ArrayClass) {
      var SubClass = function(initialCapacityOrOptions) {
        Vector2.call(this, ArrayClass, initialCapacityOrOptions);
      };
      for (var k in Vector2.prototype) {
        if (Vector2.prototype.hasOwnProperty(k))
          SubClass.prototype[k] = Vector2.prototype[k];
      }
      SubClass.from = function(iterable, capacity) {
        return Vector2.from(iterable, ArrayClass, capacity);
      };
      if (typeof Symbol !== "undefined")
        SubClass.prototype[Symbol.iterator] = SubClass.prototype.values;
      return SubClass;
    }
    Vector2.Int8Vector = subClass(Int8Array);
    Vector2.Uint8Vector = subClass(Uint8Array);
    Vector2.Uint8ClampedVector = subClass(Uint8ClampedArray);
    Vector2.Int16Vector = subClass(Int16Array);
    Vector2.Uint16Vector = subClass(Uint16Array);
    Vector2.Int32Vector = subClass(Int32Array);
    Vector2.Uint32Vector = subClass(Uint32Array);
    Vector2.Float32Vector = subClass(Float32Array);
    Vector2.Float64Vector = subClass(Float64Array);
    Vector2.PointerVector = subClass(pointerArrayFactory);
    module.exports = Vector2;
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/lru-cache.js
var require_lru_cache = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/lru-cache.js"(exports, module) {
    var Iterator = require_iterator();
    var forEach = require_foreach();
    var typed = require_typed_arrays();
    var iterables = require_iterables();
    function LRUCache(Keys, Values, capacity) {
      if (arguments.length < 2) {
        capacity = Keys;
        Keys = null;
        Values = null;
      }
      this.capacity = capacity;
      if (typeof this.capacity !== "number" || this.capacity <= 0)
        throw new Error("mnemonist/lru-cache: capacity should be positive number.");
      else if (!isFinite(this.capacity) || Math.floor(this.capacity) !== this.capacity)
        throw new Error("mnemonist/lru-cache: capacity should be a finite positive integer.");
      var PointerArray = typed.getPointerArray(capacity);
      this.forward = new PointerArray(capacity);
      this.backward = new PointerArray(capacity);
      this.K = typeof Keys === "function" ? new Keys(capacity) : new Array(capacity);
      this.V = typeof Values === "function" ? new Values(capacity) : new Array(capacity);
      this.size = 0;
      this.head = 0;
      this.tail = 0;
      this.items = {};
    }
    LRUCache.prototype.clear = function() {
      this.size = 0;
      this.head = 0;
      this.tail = 0;
      this.items = {};
    };
    LRUCache.prototype.splayOnTop = function(pointer) {
      var oldHead = this.head;
      if (this.head === pointer)
        return this;
      var previous = this.backward[pointer], next = this.forward[pointer];
      if (this.tail === pointer) {
        this.tail = previous;
      } else {
        this.backward[next] = previous;
      }
      this.forward[previous] = next;
      this.backward[oldHead] = pointer;
      this.head = pointer;
      this.forward[pointer] = oldHead;
      return this;
    };
    LRUCache.prototype.set = function(key, value) {
      var pointer = this.items[key];
      if (typeof pointer !== "undefined") {
        this.splayOnTop(pointer);
        this.V[pointer] = value;
        return;
      }
      if (this.size < this.capacity) {
        pointer = this.size++;
      } else {
        pointer = this.tail;
        this.tail = this.backward[pointer];
        delete this.items[this.K[pointer]];
      }
      this.items[key] = pointer;
      this.K[pointer] = key;
      this.V[pointer] = value;
      this.forward[pointer] = this.head;
      this.backward[this.head] = pointer;
      this.head = pointer;
    };
    LRUCache.prototype.setpop = function(key, value) {
      var oldValue = null;
      var oldKey = null;
      var evicted = false;
      var pointer = this.items[key];
      if (typeof pointer !== "undefined") {
        this.splayOnTop(pointer);
        oldValue = this.V[pointer];
        this.V[pointer] = value;
        return { evicted: false, key, value: oldValue };
      }
      if (this.size < this.capacity) {
        pointer = this.size++;
      } else {
        pointer = this.tail;
        this.tail = this.backward[pointer];
        oldValue = this.V[pointer];
        oldKey = this.K[pointer];
        delete this.items[oldKey];
        evicted = true;
      }
      this.items[key] = pointer;
      this.K[pointer] = key;
      this.V[pointer] = value;
      this.forward[pointer] = this.head;
      this.backward[this.head] = pointer;
      this.head = pointer;
      if (evicted) {
        return { evicted: true, key: oldKey, value: oldValue };
      } else {
        return null;
      }
    };
    LRUCache.prototype.has = function(key) {
      return key in this.items;
    };
    LRUCache.prototype.get = function(key) {
      var pointer = this.items[key];
      if (typeof pointer === "undefined")
        return;
      this.splayOnTop(pointer);
      return this.V[pointer];
    };
    LRUCache.prototype.peek = function(key) {
      var pointer = this.items[key];
      if (typeof pointer === "undefined")
        return;
      return this.V[pointer];
    };
    LRUCache.prototype.forEach = function(callback, scope) {
      scope = arguments.length > 1 ? scope : this;
      var i = 0, l = this.size;
      var pointer = this.head, keys = this.K, values = this.V, forward = this.forward;
      while (i < l) {
        callback.call(scope, values[pointer], keys[pointer], this);
        pointer = forward[pointer];
        i++;
      }
    };
    LRUCache.prototype.keys = function() {
      var i = 0, l = this.size;
      var pointer = this.head, keys = this.K, forward = this.forward;
      return new Iterator(function() {
        if (i >= l)
          return { done: true };
        var key = keys[pointer];
        i++;
        if (i < l)
          pointer = forward[pointer];
        return {
          done: false,
          value: key
        };
      });
    };
    LRUCache.prototype.values = function() {
      var i = 0, l = this.size;
      var pointer = this.head, values = this.V, forward = this.forward;
      return new Iterator(function() {
        if (i >= l)
          return { done: true };
        var value = values[pointer];
        i++;
        if (i < l)
          pointer = forward[pointer];
        return {
          done: false,
          value
        };
      });
    };
    LRUCache.prototype.entries = function() {
      var i = 0, l = this.size;
      var pointer = this.head, keys = this.K, values = this.V, forward = this.forward;
      return new Iterator(function() {
        if (i >= l)
          return { done: true };
        var key = keys[pointer], value = values[pointer];
        i++;
        if (i < l)
          pointer = forward[pointer];
        return {
          done: false,
          value: [key, value]
        };
      });
    };
    if (typeof Symbol !== "undefined")
      LRUCache.prototype[Symbol.iterator] = LRUCache.prototype.entries;
    LRUCache.prototype.inspect = function() {
      var proxy = /* @__PURE__ */ new Map();
      var iterator = this.entries(), step;
      while (step = iterator.next(), !step.done)
        proxy.set(step.value[0], step.value[1]);
      Object.defineProperty(proxy, "constructor", {
        value: LRUCache,
        enumerable: false
      });
      return proxy;
    };
    if (typeof Symbol !== "undefined")
      LRUCache.prototype[Symbol.for("nodejs.util.inspect.custom")] = LRUCache.prototype.inspect;
    LRUCache.from = function(iterable, Keys, Values, capacity) {
      if (arguments.length < 2) {
        capacity = iterables.guessLength(iterable);
        if (typeof capacity !== "number")
          throw new Error("mnemonist/lru-cache.from: could not guess iterable length. Please provide desired capacity as last argument.");
      } else if (arguments.length === 2) {
        capacity = Keys;
        Keys = null;
        Values = null;
      }
      var cache = new LRUCache(Keys, Values, capacity);
      forEach(iterable, function(value, key) {
        cache.set(key, value);
      });
      return cache;
    };
    module.exports = LRUCache;
  }
});

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/lru-map.js
var require_lru_map = __commonJS({
  "node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/lru-map.js"(exports, module) {
    var LRUCache = require_lru_cache();
    var forEach = require_foreach();
    var typed = require_typed_arrays();
    var iterables = require_iterables();
    function LRUMap(Keys, Values, capacity) {
      if (arguments.length < 2) {
        capacity = Keys;
        Keys = null;
        Values = null;
      }
      this.capacity = capacity;
      if (typeof this.capacity !== "number" || this.capacity <= 0)
        throw new Error("mnemonist/lru-map: capacity should be positive number.");
      else if (!isFinite(this.capacity) || Math.floor(this.capacity) !== this.capacity)
        throw new Error("mnemonist/lru-map: capacity should be a finite positive integer.");
      var PointerArray = typed.getPointerArray(capacity);
      this.forward = new PointerArray(capacity);
      this.backward = new PointerArray(capacity);
      this.K = typeof Keys === "function" ? new Keys(capacity) : new Array(capacity);
      this.V = typeof Values === "function" ? new Values(capacity) : new Array(capacity);
      this.size = 0;
      this.head = 0;
      this.tail = 0;
      this.items = /* @__PURE__ */ new Map();
    }
    LRUMap.prototype.clear = function() {
      this.size = 0;
      this.head = 0;
      this.tail = 0;
      this.items.clear();
    };
    LRUMap.prototype.set = function(key, value) {
      var pointer = this.items.get(key);
      if (typeof pointer !== "undefined") {
        this.splayOnTop(pointer);
        this.V[pointer] = value;
        return;
      }
      if (this.size < this.capacity) {
        pointer = this.size++;
      } else {
        pointer = this.tail;
        this.tail = this.backward[pointer];
        this.items.delete(this.K[pointer]);
      }
      this.items.set(key, pointer);
      this.K[pointer] = key;
      this.V[pointer] = value;
      this.forward[pointer] = this.head;
      this.backward[this.head] = pointer;
      this.head = pointer;
    };
    LRUMap.prototype.setpop = function(key, value) {
      var oldValue = null;
      var oldKey = null;
      var evicted = false;
      var pointer = this.items.get(key);
      if (typeof pointer !== "undefined") {
        this.splayOnTop(pointer);
        oldValue = this.V[pointer];
        this.V[pointer] = value;
        return { evicted: false, key, value: oldValue };
      }
      if (this.size < this.capacity) {
        pointer = this.size++;
      } else {
        pointer = this.tail;
        this.tail = this.backward[pointer];
        oldValue = this.V[pointer];
        oldKey = this.K[pointer];
        this.items.delete(oldKey);
        evicted = true;
      }
      this.items.set(key, pointer);
      this.K[pointer] = key;
      this.V[pointer] = value;
      this.forward[pointer] = this.head;
      this.backward[this.head] = pointer;
      this.head = pointer;
      if (evicted) {
        return { evicted: true, key: oldKey, value: oldValue };
      } else {
        return null;
      }
    };
    LRUMap.prototype.has = function(key) {
      return this.items.has(key);
    };
    LRUMap.prototype.get = function(key) {
      var pointer = this.items.get(key);
      if (typeof pointer === "undefined")
        return;
      this.splayOnTop(pointer);
      return this.V[pointer];
    };
    LRUMap.prototype.peek = function(key) {
      var pointer = this.items.get(key);
      if (typeof pointer === "undefined")
        return;
      return this.V[pointer];
    };
    LRUMap.prototype.splayOnTop = LRUCache.prototype.splayOnTop;
    LRUMap.prototype.forEach = LRUCache.prototype.forEach;
    LRUMap.prototype.keys = LRUCache.prototype.keys;
    LRUMap.prototype.values = LRUCache.prototype.values;
    LRUMap.prototype.entries = LRUCache.prototype.entries;
    if (typeof Symbol !== "undefined")
      LRUMap.prototype[Symbol.iterator] = LRUMap.prototype.entries;
    LRUMap.prototype.inspect = LRUCache.prototype.inspect;
    LRUMap.from = function(iterable, Keys, Values, capacity) {
      if (arguments.length < 2) {
        capacity = iterables.guessLength(iterable);
        if (typeof capacity !== "number")
          throw new Error("mnemonist/lru-cache.from: could not guess iterable length. Please provide desired capacity as last argument.");
      } else if (arguments.length === 2) {
        capacity = Keys;
        Keys = null;
        Values = null;
      }
      var cache = new LRUMap(Keys, Values, capacity);
      forEach(iterable, function(value, key) {
        cache.set(key, value);
      });
      return cache;
    };
    module.exports = LRUMap;
  }
});

// node_modules/.deno/safe-stable-stringify@2.4.3/node_modules/safe-stable-stringify/index.js
var require_safe_stable_stringify = __commonJS({
  "node_modules/.deno/safe-stable-stringify@2.4.3/node_modules/safe-stable-stringify/index.js"(exports, module) {
    "use strict";
    var { hasOwnProperty } = Object.prototype;
    var stringify = configure2();
    stringify.configure = configure2;
    stringify.stringify = stringify;
    stringify.default = stringify;
    exports.stringify = stringify;
    exports.configure = configure2;
    module.exports = stringify;
    var strEscapeSequencesRegExp = /[\u0000-\u001f\u0022\u005c\ud800-\udfff]|[\ud800-\udbff](?![\udc00-\udfff])|(?:[^\ud800-\udbff]|^)[\udc00-\udfff]/;
    function strEscape(str) {
      if (str.length < 5e3 && !strEscapeSequencesRegExp.test(str)) {
        return `"${str}"`;
      }
      return JSON.stringify(str);
    }
    function insertSort(array) {
      if (array.length > 200) {
        return array.sort();
      }
      for (let i = 1; i < array.length; i++) {
        const currentValue = array[i];
        let position = i;
        while (position !== 0 && array[position - 1] > currentValue) {
          array[position] = array[position - 1];
          position--;
        }
        array[position] = currentValue;
      }
      return array;
    }
    var typedArrayPrototypeGetSymbolToStringTag = Object.getOwnPropertyDescriptor(
      Object.getPrototypeOf(
        Object.getPrototypeOf(
          new Int8Array()
        )
      ),
      Symbol.toStringTag
    ).get;
    function isTypedArrayWithEntries(value) {
      return typedArrayPrototypeGetSymbolToStringTag.call(value) !== void 0 && value.length !== 0;
    }
    function stringifyTypedArray(array, separator, maximumBreadth) {
      if (array.length < maximumBreadth) {
        maximumBreadth = array.length;
      }
      const whitespace = separator === "," ? "" : " ";
      let res = `"0":${whitespace}${array[0]}`;
      for (let i = 1; i < maximumBreadth; i++) {
        res += `${separator}"${i}":${whitespace}${array[i]}`;
      }
      return res;
    }
    function getCircularValueOption(options) {
      if (hasOwnProperty.call(options, "circularValue")) {
        const circularValue = options.circularValue;
        if (typeof circularValue === "string") {
          return `"${circularValue}"`;
        }
        if (circularValue == null) {
          return circularValue;
        }
        if (circularValue === Error || circularValue === TypeError) {
          return {
            toString() {
              throw new TypeError("Converting circular structure to JSON");
            }
          };
        }
        throw new TypeError('The "circularValue" argument must be of type string or the value null or undefined');
      }
      return '"[Circular]"';
    }
    function getBooleanOption(options, key) {
      let value;
      if (hasOwnProperty.call(options, key)) {
        value = options[key];
        if (typeof value !== "boolean") {
          throw new TypeError(`The "${key}" argument must be of type boolean`);
        }
      }
      return value === void 0 ? true : value;
    }
    function getPositiveIntegerOption(options, key) {
      let value;
      if (hasOwnProperty.call(options, key)) {
        value = options[key];
        if (typeof value !== "number") {
          throw new TypeError(`The "${key}" argument must be of type number`);
        }
        if (!Number.isInteger(value)) {
          throw new TypeError(`The "${key}" argument must be an integer`);
        }
        if (value < 1) {
          throw new RangeError(`The "${key}" argument must be >= 1`);
        }
      }
      return value === void 0 ? Infinity : value;
    }
    function getItemCount(number) {
      if (number === 1) {
        return "1 item";
      }
      return `${number} items`;
    }
    function getUniqueReplacerSet(replacerArray) {
      const replacerSet = /* @__PURE__ */ new Set();
      for (const value of replacerArray) {
        if (typeof value === "string" || typeof value === "number") {
          replacerSet.add(String(value));
        }
      }
      return replacerSet;
    }
    function getStrictOption(options) {
      if (hasOwnProperty.call(options, "strict")) {
        const value = options.strict;
        if (typeof value !== "boolean") {
          throw new TypeError('The "strict" argument must be of type boolean');
        }
        if (value) {
          return (value2) => {
            let message = `Object can not safely be stringified. Received type ${typeof value2}`;
            if (typeof value2 !== "function") message += ` (${value2.toString()})`;
            throw new Error(message);
          };
        }
      }
    }
    function configure2(options) {
      options = { ...options };
      const fail = getStrictOption(options);
      if (fail) {
        if (options.bigint === void 0) {
          options.bigint = false;
        }
        if (!("circularValue" in options)) {
          options.circularValue = Error;
        }
      }
      const circularValue = getCircularValueOption(options);
      const bigint = getBooleanOption(options, "bigint");
      const deterministic = getBooleanOption(options, "deterministic");
      const maximumDepth = getPositiveIntegerOption(options, "maximumDepth");
      const maximumBreadth = getPositiveIntegerOption(options, "maximumBreadth");
      function stringifyFnReplacer(key, parent, stack, replacer, spacer, indentation) {
        let value = parent[key];
        if (typeof value === "object" && value !== null && typeof value.toJSON === "function") {
          value = value.toJSON(key);
        }
        value = replacer.call(parent, key, value);
        switch (typeof value) {
          case "string":
            return strEscape(value);
          case "object": {
            if (value === null) {
              return "null";
            }
            if (stack.indexOf(value) !== -1) {
              return circularValue;
            }
            let res = "";
            let join = ",";
            const originalIndentation = indentation;
            if (Array.isArray(value)) {
              if (value.length === 0) {
                return "[]";
              }
              if (maximumDepth < stack.length + 1) {
                return '"[Array]"';
              }
              stack.push(value);
              if (spacer !== "") {
                indentation += spacer;
                res += `
${indentation}`;
                join = `,
${indentation}`;
              }
              const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
              let i = 0;
              for (; i < maximumValuesToStringify - 1; i++) {
                const tmp2 = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation);
                res += tmp2 !== void 0 ? tmp2 : "null";
                res += join;
              }
              const tmp = stringifyFnReplacer(String(i), value, stack, replacer, spacer, indentation);
              res += tmp !== void 0 ? tmp : "null";
              if (value.length - 1 > maximumBreadth) {
                const removedKeys = value.length - maximumBreadth - 1;
                res += `${join}"... ${getItemCount(removedKeys)} not stringified"`;
              }
              if (spacer !== "") {
                res += `
${originalIndentation}`;
              }
              stack.pop();
              return `[${res}]`;
            }
            let keys = Object.keys(value);
            const keyLength = keys.length;
            if (keyLength === 0) {
              return "{}";
            }
            if (maximumDepth < stack.length + 1) {
              return '"[Object]"';
            }
            let whitespace = "";
            let separator = "";
            if (spacer !== "") {
              indentation += spacer;
              join = `,
${indentation}`;
              whitespace = " ";
            }
            const maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);
            if (deterministic && !isTypedArrayWithEntries(value)) {
              keys = insertSort(keys);
            }
            stack.push(value);
            for (let i = 0; i < maximumPropertiesToStringify; i++) {
              const key2 = keys[i];
              const tmp = stringifyFnReplacer(key2, value, stack, replacer, spacer, indentation);
              if (tmp !== void 0) {
                res += `${separator}${strEscape(key2)}:${whitespace}${tmp}`;
                separator = join;
              }
            }
            if (keyLength > maximumBreadth) {
              const removedKeys = keyLength - maximumBreadth;
              res += `${separator}"...":${whitespace}"${getItemCount(removedKeys)} not stringified"`;
              separator = join;
            }
            if (spacer !== "" && separator.length > 1) {
              res = `
${indentation}${res}
${originalIndentation}`;
            }
            stack.pop();
            return `{${res}}`;
          }
          case "number":
            return isFinite(value) ? String(value) : fail ? fail(value) : "null";
          case "boolean":
            return value === true ? "true" : "false";
          case "undefined":
            return void 0;
          case "bigint":
            if (bigint) {
              return String(value);
            }
          // fallthrough
          default:
            return fail ? fail(value) : void 0;
        }
      }
      function stringifyArrayReplacer(key, value, stack, replacer, spacer, indentation) {
        if (typeof value === "object" && value !== null && typeof value.toJSON === "function") {
          value = value.toJSON(key);
        }
        switch (typeof value) {
          case "string":
            return strEscape(value);
          case "object": {
            if (value === null) {
              return "null";
            }
            if (stack.indexOf(value) !== -1) {
              return circularValue;
            }
            const originalIndentation = indentation;
            let res = "";
            let join = ",";
            if (Array.isArray(value)) {
              if (value.length === 0) {
                return "[]";
              }
              if (maximumDepth < stack.length + 1) {
                return '"[Array]"';
              }
              stack.push(value);
              if (spacer !== "") {
                indentation += spacer;
                res += `
${indentation}`;
                join = `,
${indentation}`;
              }
              const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
              let i = 0;
              for (; i < maximumValuesToStringify - 1; i++) {
                const tmp2 = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation);
                res += tmp2 !== void 0 ? tmp2 : "null";
                res += join;
              }
              const tmp = stringifyArrayReplacer(String(i), value[i], stack, replacer, spacer, indentation);
              res += tmp !== void 0 ? tmp : "null";
              if (value.length - 1 > maximumBreadth) {
                const removedKeys = value.length - maximumBreadth - 1;
                res += `${join}"... ${getItemCount(removedKeys)} not stringified"`;
              }
              if (spacer !== "") {
                res += `
${originalIndentation}`;
              }
              stack.pop();
              return `[${res}]`;
            }
            stack.push(value);
            let whitespace = "";
            if (spacer !== "") {
              indentation += spacer;
              join = `,
${indentation}`;
              whitespace = " ";
            }
            let separator = "";
            for (const key2 of replacer) {
              const tmp = stringifyArrayReplacer(key2, value[key2], stack, replacer, spacer, indentation);
              if (tmp !== void 0) {
                res += `${separator}${strEscape(key2)}:${whitespace}${tmp}`;
                separator = join;
              }
            }
            if (spacer !== "" && separator.length > 1) {
              res = `
${indentation}${res}
${originalIndentation}`;
            }
            stack.pop();
            return `{${res}}`;
          }
          case "number":
            return isFinite(value) ? String(value) : fail ? fail(value) : "null";
          case "boolean":
            return value === true ? "true" : "false";
          case "undefined":
            return void 0;
          case "bigint":
            if (bigint) {
              return String(value);
            }
          // fallthrough
          default:
            return fail ? fail(value) : void 0;
        }
      }
      function stringifyIndent(key, value, stack, spacer, indentation) {
        switch (typeof value) {
          case "string":
            return strEscape(value);
          case "object": {
            if (value === null) {
              return "null";
            }
            if (typeof value.toJSON === "function") {
              value = value.toJSON(key);
              if (typeof value !== "object") {
                return stringifyIndent(key, value, stack, spacer, indentation);
              }
              if (value === null) {
                return "null";
              }
            }
            if (stack.indexOf(value) !== -1) {
              return circularValue;
            }
            const originalIndentation = indentation;
            if (Array.isArray(value)) {
              if (value.length === 0) {
                return "[]";
              }
              if (maximumDepth < stack.length + 1) {
                return '"[Array]"';
              }
              stack.push(value);
              indentation += spacer;
              let res2 = `
${indentation}`;
              const join2 = `,
${indentation}`;
              const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
              let i = 0;
              for (; i < maximumValuesToStringify - 1; i++) {
                const tmp2 = stringifyIndent(String(i), value[i], stack, spacer, indentation);
                res2 += tmp2 !== void 0 ? tmp2 : "null";
                res2 += join2;
              }
              const tmp = stringifyIndent(String(i), value[i], stack, spacer, indentation);
              res2 += tmp !== void 0 ? tmp : "null";
              if (value.length - 1 > maximumBreadth) {
                const removedKeys = value.length - maximumBreadth - 1;
                res2 += `${join2}"... ${getItemCount(removedKeys)} not stringified"`;
              }
              res2 += `
${originalIndentation}`;
              stack.pop();
              return `[${res2}]`;
            }
            let keys = Object.keys(value);
            const keyLength = keys.length;
            if (keyLength === 0) {
              return "{}";
            }
            if (maximumDepth < stack.length + 1) {
              return '"[Object]"';
            }
            indentation += spacer;
            const join = `,
${indentation}`;
            let res = "";
            let separator = "";
            let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);
            if (isTypedArrayWithEntries(value)) {
              res += stringifyTypedArray(value, join, maximumBreadth);
              keys = keys.slice(value.length);
              maximumPropertiesToStringify -= value.length;
              separator = join;
            }
            if (deterministic) {
              keys = insertSort(keys);
            }
            stack.push(value);
            for (let i = 0; i < maximumPropertiesToStringify; i++) {
              const key2 = keys[i];
              const tmp = stringifyIndent(key2, value[key2], stack, spacer, indentation);
              if (tmp !== void 0) {
                res += `${separator}${strEscape(key2)}: ${tmp}`;
                separator = join;
              }
            }
            if (keyLength > maximumBreadth) {
              const removedKeys = keyLength - maximumBreadth;
              res += `${separator}"...": "${getItemCount(removedKeys)} not stringified"`;
              separator = join;
            }
            if (separator !== "") {
              res = `
${indentation}${res}
${originalIndentation}`;
            }
            stack.pop();
            return `{${res}}`;
          }
          case "number":
            return isFinite(value) ? String(value) : fail ? fail(value) : "null";
          case "boolean":
            return value === true ? "true" : "false";
          case "undefined":
            return void 0;
          case "bigint":
            if (bigint) {
              return String(value);
            }
          // fallthrough
          default:
            return fail ? fail(value) : void 0;
        }
      }
      function stringifySimple(key, value, stack) {
        switch (typeof value) {
          case "string":
            return strEscape(value);
          case "object": {
            if (value === null) {
              return "null";
            }
            if (typeof value.toJSON === "function") {
              value = value.toJSON(key);
              if (typeof value !== "object") {
                return stringifySimple(key, value, stack);
              }
              if (value === null) {
                return "null";
              }
            }
            if (stack.indexOf(value) !== -1) {
              return circularValue;
            }
            let res = "";
            if (Array.isArray(value)) {
              if (value.length === 0) {
                return "[]";
              }
              if (maximumDepth < stack.length + 1) {
                return '"[Array]"';
              }
              stack.push(value);
              const maximumValuesToStringify = Math.min(value.length, maximumBreadth);
              let i = 0;
              for (; i < maximumValuesToStringify - 1; i++) {
                const tmp2 = stringifySimple(String(i), value[i], stack);
                res += tmp2 !== void 0 ? tmp2 : "null";
                res += ",";
              }
              const tmp = stringifySimple(String(i), value[i], stack);
              res += tmp !== void 0 ? tmp : "null";
              if (value.length - 1 > maximumBreadth) {
                const removedKeys = value.length - maximumBreadth - 1;
                res += `,"... ${getItemCount(removedKeys)} not stringified"`;
              }
              stack.pop();
              return `[${res}]`;
            }
            let keys = Object.keys(value);
            const keyLength = keys.length;
            if (keyLength === 0) {
              return "{}";
            }
            if (maximumDepth < stack.length + 1) {
              return '"[Object]"';
            }
            let separator = "";
            let maximumPropertiesToStringify = Math.min(keyLength, maximumBreadth);
            if (isTypedArrayWithEntries(value)) {
              res += stringifyTypedArray(value, ",", maximumBreadth);
              keys = keys.slice(value.length);
              maximumPropertiesToStringify -= value.length;
              separator = ",";
            }
            if (deterministic) {
              keys = insertSort(keys);
            }
            stack.push(value);
            for (let i = 0; i < maximumPropertiesToStringify; i++) {
              const key2 = keys[i];
              const tmp = stringifySimple(key2, value[key2], stack);
              if (tmp !== void 0) {
                res += `${separator}${strEscape(key2)}:${tmp}`;
                separator = ",";
              }
            }
            if (keyLength > maximumBreadth) {
              const removedKeys = keyLength - maximumBreadth;
              res += `${separator}"...":"${getItemCount(removedKeys)} not stringified"`;
            }
            stack.pop();
            return `{${res}}`;
          }
          case "number":
            return isFinite(value) ? String(value) : fail ? fail(value) : "null";
          case "boolean":
            return value === true ? "true" : "false";
          case "undefined":
            return void 0;
          case "bigint":
            if (bigint) {
              return String(value);
            }
          // fallthrough
          default:
            return fail ? fail(value) : void 0;
        }
      }
      function stringify2(value, replacer, space) {
        if (arguments.length > 1) {
          let spacer = "";
          if (typeof space === "number") {
            spacer = " ".repeat(Math.min(space, 10));
          } else if (typeof space === "string") {
            spacer = space.slice(0, 10);
          }
          if (replacer != null) {
            if (typeof replacer === "function") {
              return stringifyFnReplacer("", { "": value }, [], replacer, spacer, "");
            }
            if (Array.isArray(replacer)) {
              return stringifyArrayReplacer("", value, [], getUniqueReplacerSet(replacer), spacer, "");
            }
          }
          if (spacer.length !== 0) {
            return stringifyIndent("", value, [], spacer, "");
          }
        }
        return stringifySimple("", value, []);
      }
      return stringify2;
    }
  }
});

// src/shared/types.ts
var DataRefType = /* @__PURE__ */ ((DataRefType2) => {
  DataRefType2["base64"] = "base64";
  DataRefType2["url"] = "url";
  DataRefType2["utf8"] = "utf8";
  DataRefType2["json"] = "json";
  DataRefType2["key"] = "key";
  return DataRefType2;
})(DataRefType || {});
var DataRefTypeKeys = Object.keys(DataRefType).filter((key) => isNaN(Number(key)));
var DataRefTypesSet = new Set(DataRefTypeKeys);
var DataRefTypeDefault = "utf8" /* utf8 */;
var isDataRef = (value) => {
  return !!(value && typeof value === "object" && value?.type && DataRefTypesSet.has(value.type) && value?.value);
};
var DefaultNamespace = "_";
var DockerJobState = /* @__PURE__ */ ((DockerJobState2) => {
  DockerJobState2["Queued"] = "Queued";
  DockerJobState2["Running"] = "Running";
  DockerJobState2["Finished"] = "Finished";
  DockerJobState2["Removed"] = "Removed";
  return DockerJobState2;
})(DockerJobState || {});
var DockerJobFinishedReason = /* @__PURE__ */ ((DockerJobFinishedReason2) => {
  DockerJobFinishedReason2["Cancelled"] = "Cancelled";
  DockerJobFinishedReason2["Error"] = "Error";
  DockerJobFinishedReason2["JobReplacedByClient"] = "JobReplacedByClient";
  DockerJobFinishedReason2["Success"] = "Success";
  DockerJobFinishedReason2["TimedOut"] = "TimedOut";
  DockerJobFinishedReason2["WorkerLost"] = "WorkerLost";
  DockerJobFinishedReason2["Deleted"] = "Deleted";
  return DockerJobFinishedReason2;
})(DockerJobFinishedReason || {});
var isFinalDockerJobFinishedReason = (reason) => {
  return reason === "Error" /* Error */ || reason === "Success" /* Success */ || reason === "TimedOut" /* TimedOut */;
};
var enqueuedToInMemoryDockerJob = (enqueued) => {
  const queuedTime = Date.now();
  return {
    queuedTime,
    state: "Queued" /* Queued */,
    time: queuedTime,
    worker: "",
    namespaces: enqueued.control?.namespace ? [enqueued.control.namespace] : [],
    tags: enqueued.definition.tags
  };
};
var isDockerJobDefinitionRowFinished = (row) => {
  return row.state === "Finished" /* Finished */;
};
var getFinishedJobState = (row) => {
  if (isDockerJobDefinitionRowFinished(row)) {
    return row.value;
  }
};
var WebsocketMessageTypeWorkerToServer = /* @__PURE__ */ ((WebsocketMessageTypeWorkerToServer2) => {
  WebsocketMessageTypeWorkerToServer2["StateChange"] = "StateChange";
  WebsocketMessageTypeWorkerToServer2["WorkerRegistration"] = "WorkerRegistration";
  WebsocketMessageTypeWorkerToServer2["WorkerStatusResponse"] = "WorkerStatusResponse";
  WebsocketMessageTypeWorkerToServer2["JobStatusLogs"] = "JobStatusLogs";
  WebsocketMessageTypeWorkerToServer2["RequestJobDefinitions"] = "RequestJobDefinitions";
  return WebsocketMessageTypeWorkerToServer2;
})(WebsocketMessageTypeWorkerToServer || {});
var WebsocketMessageTypeClientToServer = /* @__PURE__ */ ((WebsocketMessageTypeClientToServer2) => {
  WebsocketMessageTypeClientToServer2["StateChange"] = "StateChange";
  WebsocketMessageTypeClientToServer2["QueryJob"] = "QueryJob";
  WebsocketMessageTypeClientToServer2["QueryJobStates"] = "QueryJobStates";
  return WebsocketMessageTypeClientToServer2;
})(WebsocketMessageTypeClientToServer || {});
var WebsocketMessageTypeServerBroadcast = /* @__PURE__ */ ((WebsocketMessageTypeServerBroadcast2) => {
  WebsocketMessageTypeServerBroadcast2["JobStates"] = "JobStates";
  WebsocketMessageTypeServerBroadcast2["JobStateUpdates"] = "JobStateUpdates";
  WebsocketMessageTypeServerBroadcast2["JobStatusPayload"] = "JobStatusPayload";
  WebsocketMessageTypeServerBroadcast2["Workers"] = "Workers";
  WebsocketMessageTypeServerBroadcast2["StatusRequest"] = "StatusRequest";
  WebsocketMessageTypeServerBroadcast2["ClearJobCache"] = "ClearJobCache";
  WebsocketMessageTypeServerBroadcast2["BroadcastJobDefinitions"] = "BroadcastJobDefinitions";
  return WebsocketMessageTypeServerBroadcast2;
})(WebsocketMessageTypeServerBroadcast || {});
var isJobCacheAllowedToBeDeleted = (state) => {
  switch (state) {
    case "Queued" /* Queued */:
    case "Running" /* Running */:
      return false;
    case "Finished" /* Finished */:
      return true;
    default:
      return false;
  }
};

// src/shared/util.ts
var import_fetch_retry = __toESM(require_fetch_retry_umd());

// node_modules/.deno/mnemonist@0.40.6/node_modules/mnemonist/index.mjs
var import_fibonacci_heap = __toESM(require_fibonacci_heap(), 1);
var import_heap = __toESM(require_heap(), 1);
var import_suffix_array = __toESM(require_suffix_array(), 1);
var import_vector = __toESM(require_vector(), 1);
var import_lru_map = __toESM(require_lru_map(), 1);
var MinFibonacciHeap = import_fibonacci_heap.default.MinFibonacciHeap;
var MaxFibonacciHeap = import_fibonacci_heap.default.MaxFibonacciHeap;
var MinHeap = import_heap.default.MinHeap;
var MaxHeap = import_heap.default.MaxHeap;
var GeneralizedSuffixArray = import_suffix_array.default.GeneralizedSuffixArray;
var Uint8Vector = import_vector.default.Uint8Vector;
var Uint8ClampedVector = import_vector.default.Uint8ClampedVector;
var Int8Vector = import_vector.default.Int8Vector;
var Uint16Vector = import_vector.default.Uint16Vector;
var Int16Vector = import_vector.default.Int16Vector;
var Uint32Vector = import_vector.default.Uint32Vector;
var Int32Vector = import_vector.default.Int32Vector;
var Float32Vector = import_vector.default.Float32Vector;
var Float64Vector = import_vector.default.Float64Vector;
var PointerVector = import_vector.default.PointerVector;

// node_modules/.deno/safe-stable-stringify@2.4.3/node_modules/safe-stable-stringify/esm/wrapper.js
var import__ = __toESM(require_safe_stable_stringify());
var configure = import__.default.configure;
var wrapper_default = import__.default;

// src/shared/util.ts
var getJobStateString = (job) => {
  if (!job) {
    return "__";
  }
  return job.state === "Finished" /* Finished */ ? `Finished(${job.finishedReason})` : `${job.state}`;
};
var isFinishedStateWorthCaching = (reason) => {
  switch (reason) {
    case "Success" /* Success */:
    case "TimedOut" /* TimedOut */:
    case "Error" /* Error */:
      return true;
    default:
      return false;
  }
};
var isJobDeletedOrRemoved = (job) => {
  return job?.state === "Removed" /* Removed */ || job?.finishedReason === "Deleted" /* Deleted */;
};
var isJobOkForSending = (job) => {
  if (!job) {
    return false;
  }
  if (job.state === "Removed" /* Removed */) {
    return false;
  }
  if (job.state === "Finished" /* Finished */) {
    switch (job.finishedReason) {
      case "WorkerLost" /* WorkerLost */:
      case "JobReplacedByClient" /* JobReplacedByClient */:
      case "Cancelled" /* Cancelled */:
      case "Deleted" /* Deleted */:
        return false;
      default:
        break;
    }
  }
  return true;
};
var setJobStateRunning = (job, args) => {
  const { worker, time } = args;
  const newJob = {
    ...job,
    state: "Running" /* Running */,
    worker,
    time
  };
  delete newJob.finished;
  delete newJob.finishedReason;
  return newJob;
};
var setJobStateQueued = (job, args) => {
  const { time } = args;
  const newJob = {
    ...job,
    state: "Queued" /* Queued */,
    time
  };
  delete newJob.finished;
  delete newJob.finishedReason;
  newJob.worker = "";
  return newJob;
};
var setJobStateReQueued = (job, args) => {
  const { time } = args;
  const newJob = {
    ...job,
    state: "Queued" /* Queued */,
    time
  };
  delete newJob.finished;
  delete newJob.finishedReason;
  newJob.worker = "";
  return newJob;
};
var setJobStateFinished = (job, args) => {
  const { finished } = args;
  const newJob = {
    ...job,
    state: "Finished" /* Finished */,
    finishedReason: finished.reason,
    time: finished.time,
    finished
  };
  return newJob;
};
var setJobStateRemoved = (job) => {
  const newJob = {
    ...job,
    state: "Removed" /* Removed */
  };
  delete newJob.finished;
  delete newJob.finishedReason;
  return newJob;
};
var formatDefinitionS3Key = (id) => {
  return `j/${id}/definition.json`;
};
var formatResultsS3Key = (id) => {
  return `j/${id}/result.json`;
};
var resolvePreferredWorker = (workerA, workerB) => {
  return workerA.localeCompare(workerB) < 0 ? workerA : workerB;
};
function sanitizeFilename(filename) {
  let sanitized = filename.replace(/[/\\:*?"<>|\0]/g, "_");
  sanitized = sanitized.replace(/[^a-zA-Z0-9_\-.]/g, "_");
  sanitized = sanitized.replace(/^\.+/, "");
  sanitized = sanitized.trim();
  const reserved = [
    "con",
    "prn",
    "aux",
    "nul",
    "com1",
    "com2",
    "com3",
    "com4",
    "com5",
    "com6",
    "com7",
    "com8",
    "com9",
    "lpt1",
    "lpt2",
    "lpt3",
    "lpt4",
    "lpt5",
    "lpt6",
    "lpt7",
    "lpt8",
    "lpt9"
  ];
  if (reserved.includes(sanitized.split(".")[0])) {
    sanitized = sanitized + "_";
  }
  sanitized = sanitized.substring(0, 255);
  return sanitized;
}
var cleanInputsRefsForHash = (refs) => {
  if (!refs) return void 0;
  const cleaned = {};
  for (const key of Object.keys(refs)) {
    const ref = refs[key];
    let value = ref.value;
    if (ref.type === "url" && typeof value === "string") {
      value = reduceUrlToHashVersion(value);
    }
    const entry = { value };
    if (ref.type != null) entry.type = ref.type;
    cleaned[key] = entry;
  }
  return cleaned;
};
var ParentInjectedHashParamPrefix = /^mp[-_]/;
var ParentInjectedHashParamKeysLegacy = /* @__PURE__ */ new Set([
  // deprecated spelling of mp-channel
  "channel",
  "CHANNEL",
  // injected only when the viewer does not own the metaframe, so it would
  // otherwise make job ids differ between viewers of the same metapage
  "readonly",
  "edit",
  "parent-metapage-id",
  "fs-path"
]);
var isParentInjectedHashParamKey = (key) => ParentInjectedHashParamPrefix.test(key) || ParentInjectedHashParamKeysLegacy.has(key);
var buildJobHashBlob = (job) => {
  const blob = {};
  if (job.v != null) blob.v = job.v;
  if (job.image != null) blob.image = job.image;
  if (job.command != null) blob.command = job.command;
  if (job.entrypoint != null) blob.entrypoint = job.entrypoint;
  if (job.workdir != null) blob.workdir = job.workdir;
  if (job.shmSize != null) blob.shmSize = job.shmSize;
  if (job.maxDuration != null) blob.maxDuration = job.maxDuration;
  if (job.tags != null) blob.tags = job.tags;
  if (job.build) {
    const build = {};
    if (job.build.context != null) build.context = job.build.context;
    if (job.build.buildContext != null) build.buildContext = job.build.buildContext;
    if (job.build.filename != null) build.filename = job.build.filename;
    if (job.build.target != null) build.target = job.build.target;
    if (job.build.dockerfile != null) build.dockerfile = job.build.dockerfile;
    if (job.build.buildArgs != null) build.buildArgs = job.build.buildArgs;
    if (job.build.platform != null) build.platform = job.build.platform;
    if (Object.keys(build).length > 0) {
      blob.build = build;
    }
  }
  if (job.requirements) {
    const reqs = {};
    if (job.requirements.cpus != null) reqs.cpus = job.requirements.cpus;
    if (job.requirements.gpus != null) reqs.gpus = job.requirements.gpus;
    if (job.requirements.maxDuration != null) reqs.maxDuration = job.requirements.maxDuration;
    if (job.requirements.memory != null) reqs.memory = job.requirements.memory;
    if (Object.keys(reqs).length > 0) {
      blob.requirements = reqs;
    }
  }
  if (job.env) {
    const env = {};
    for (const key of Object.keys(job.env)) {
      if (isParentInjectedHashParamKey(key)) continue;
      env[key] = job.env[key];
    }
    if (Object.keys(env).length > 0) {
      blob.env = env;
    }
  }
  const cleanedInputs = cleanInputsRefsForHash(job.inputs);
  if (cleanedInputs && Object.keys(cleanedInputs).length > 0) {
    blob.inputs = cleanedInputs;
  }
  const cleanedConfigFiles = cleanInputsRefsForHash(job.configFiles);
  if (cleanedConfigFiles && Object.keys(cleanedConfigFiles).length > 0) {
    blob.configFiles = cleanedConfigFiles;
  }
  return blob;
};
var shaDockerJob = (job) => {
  if (!job) {
    throw new Error("shaDockerJob: job is undefined");
  }
  const blob = buildJobHashBlob(job);
  return shaObject(blob);
};
var reduceUrlToHashVersion = (url) => {
  if (url.includes("/presignedurl/")) {
    const tokens = url.split("/presignedurl/");
    return tokens[0];
  }
  if (url.startsWith("https://metaframe-asman-test.s3.us-west-1.amazonaws.com")) {
    const urlBlob = new URL(url);
    urlBlob.search = "";
    urlBlob.hash = "";
    return urlBlob.href;
  }
  return url;
};
var shaObject = (obj) => {
  const orderedStringFromObject = wrapper_default(obj);
  const msgBuffer = new TextEncoder().encode(orderedStringFromObject);
  return sha256Buffer(msgBuffer);
};
var sha256Buffer = async (buffer) => {
  const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join(
    ""
  );
  return hashHex;
};
var fetchRobust = (0, import_fetch_retry.default)(fetch, {
  retries: 5,
  // eslint-disable-next-line
  retryDelay: (attempt, _error, _response) => {
    return Math.pow(2, attempt) * 100;
  },
  retryOn: (attempt, error, response) => {
    if (error !== null || response && response.status >= 400) {
      if (attempt > 7) {
        if (error) {
          console.error(error);
        }
        console.log(
          `Retried too many times: response.status=${response?.status} response.statusText=${response?.statusText} attempt number ${attempt + 1} url=${response?.url}`
        );
        return false;
      }
      return true;
    }
    return false;
  }
});
var resolveMostCorrectJob = (jobA, jobB) => {
  if (jobA && !jobB) {
    return jobA;
  }
  if (!jobA && jobB) {
    return jobB;
  }
  switch (jobA.state) {
    case "Queued" /* Queued */:
      switch (jobB.state) {
        case "Queued" /* Queued */:
          return jobA.time < jobB.time ? jobA : jobB;
        case "Running" /* Running */:
          return jobB;
        case "Finished" /* Finished */:
          switch (jobB.finishedReason) {
            case "Success" /* Success */:
              return jobB;
            case "TimedOut" /* TimedOut */:
              return jobB;
            case "Error" /* Error */:
              return jobB;
            case "WorkerLost" /* WorkerLost */:
              return jobA;
            case "JobReplacedByClient" /* JobReplacedByClient */:
              return jobB;
            case "Cancelled" /* Cancelled */:
              return jobA.time > jobB.time ? jobA : jobB;
            case "Deleted" /* Deleted */:
              return jobA;
            default:
              return jobA;
          }
        case "Removed" /* Removed */:
          return jobA;
        default:
          return jobA;
      }
    case "Running" /* Running */:
      switch (jobB.state) {
        case "Running" /* Running */: {
          if (jobA.worker === jobB.worker) {
            return jobA;
          }
          const workerA = jobA.worker;
          const workerB = jobB.worker;
          const preferredWorker = resolvePreferredWorker(
            workerA,
            workerB
          );
          if (preferredWorker === workerA) {
            return jobA;
          } else {
            return jobB;
          }
        }
        case "Finished" /* Finished */:
          return jobB;
        case "Removed" /* Removed */:
          return jobA;
        // Running -> Finished -> Removed, Removed cannot skip over Finished
        default:
          return jobA;
      }
    case "Finished" /* Finished */:
      switch (jobB.state) {
        case "Queued" /* Queued */:
          switch (jobA.finishedReason) {
            case "Success" /* Success */:
              return jobA;
            case "TimedOut" /* TimedOut */:
              return jobA;
            case "Error" /* Error */:
              return jobA;
            case "WorkerLost" /* WorkerLost */:
              return jobB;
            case "JobReplacedByClient" /* JobReplacedByClient */:
              return jobA;
            case "Cancelled" /* Cancelled */:
              return jobB.time > jobA.time ? jobB : jobA;
            case "Deleted" /* Deleted */:
              return jobB;
            default:
              return jobB;
          }
        case "Running" /* Running */:
          return jobA;
        case "Finished" /* Finished */:
          switch (jobA.finishedReason) {
            case "Success" /* Success */:
              switch (jobB.finishedReason) {
                case "Success" /* Success */:
                  return jobA.time < jobB.time ? jobA : jobB;
                case "TimedOut" /* TimedOut */:
                  return jobA;
                case "Error" /* Error */:
                  return jobA;
                case "WorkerLost" /* WorkerLost */:
                  return jobA;
                case "JobReplacedByClient" /* JobReplacedByClient */:
                  return jobA;
                case "Cancelled" /* Cancelled */:
                  return jobB;
                case "Deleted" /* Deleted */:
                  return jobB;
                default:
                  return jobA;
              }
            case "TimedOut" /* TimedOut */:
              switch (jobB.finishedReason) {
                case "Success" /* Success */:
                  return jobB;
                case "TimedOut" /* TimedOut */:
                  return jobA.time < jobB.time ? jobA : jobB;
                case "Error" /* Error */:
                  return jobB;
                case "WorkerLost" /* WorkerLost */:
                  return jobB;
                case "JobReplacedByClient" /* JobReplacedByClient */:
                  return jobA;
                case "Cancelled" /* Cancelled */:
                  return jobA;
                case "Deleted" /* Deleted */:
                  return jobB;
                default:
                  return jobA;
              }
            case "Error" /* Error */:
              switch (jobB.finishedReason) {
                case "Success" /* Success */:
                  return jobB;
                case "TimedOut" /* TimedOut */:
                  return jobA;
                case "Error" /* Error */:
                  return jobA.time < jobB.time ? jobA : jobB;
                case "WorkerLost" /* WorkerLost */:
                  return jobA;
                case "JobReplacedByClient" /* JobReplacedByClient */:
                  return jobA;
                case "Cancelled" /* Cancelled */:
                  return jobA;
                case "Deleted" /* Deleted */:
                  return jobB;
                default:
                  return jobA;
              }
            case "WorkerLost" /* WorkerLost */:
              return jobB;
            case "JobReplacedByClient" /* JobReplacedByClient */:
              switch (jobB.finishedReason) {
                case "Success" /* Success */:
                  return jobB;
                case "TimedOut" /* TimedOut */:
                  return jobB;
                case "Error" /* Error */:
                  return jobB;
                case "WorkerLost" /* WorkerLost */:
                  return jobA;
                case "JobReplacedByClient" /* JobReplacedByClient */:
                  return jobA;
                case "Cancelled" /* Cancelled */:
                  return jobA;
                case "Deleted" /* Deleted */:
                  return jobB;
                default:
                  return jobB;
              }
            case "Cancelled" /* Cancelled */:
              switch (jobB.finishedReason) {
                case "Success" /* Success */:
                  return jobA;
                case "TimedOut" /* TimedOut */:
                  return jobB;
                case "Error" /* Error */:
                  return jobB;
                case "WorkerLost" /* WorkerLost */:
                  return jobA;
                case "JobReplacedByClient" /* JobReplacedByClient */:
                  return jobA;
                case "Cancelled" /* Cancelled */:
                  return jobA;
                case "Deleted" /* Deleted */:
                  return jobB;
                default:
                  return jobB;
              }
            case "Deleted" /* Deleted */:
              switch (jobB.finishedReason) {
                case "Success" /* Success */:
                  return jobA;
                case "TimedOut" /* TimedOut */:
                  return jobA;
                case "Error" /* Error */:
                  return jobA;
                case "WorkerLost" /* WorkerLost */:
                  return jobA;
                case "JobReplacedByClient" /* JobReplacedByClient */:
                  return jobA;
                case "Cancelled" /* Cancelled */:
                  return jobA;
                case "Deleted" /* Deleted */:
                  return jobA;
                default:
                  return jobB;
              }
            default:
              return jobB;
          }
        case "Removed" /* Removed */:
          return jobB;
        // Finished -> Removed
        default:
          return jobA;
      }
    case "Removed" /* Removed */:
      switch (jobB.state) {
        case "Queued" /* Queued */:
          return jobB;
        case "Running" /* Running */:
          return jobB;
        case "Finished" /* Finished */:
          return jobA;
        case "Removed" /* Removed */:
          return jobA.time < jobB.time ? jobA : jobB;
        default:
          return jobA;
      }
    default:
      return jobA;
  }
};
var jobColorCache = new import_lru_map.default(1e3);
var getJobColorizedString = (jobId) => {
  if (!jobId) {
    return jobId;
  }
  const cachedColor = jobColorCache.get(jobId);
  if (cachedColor) {
    return cachedColor;
  }
  let hash = 0;
  for (let i = 0; i < jobId.length; i++) {
    const char = jobId.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  const colorStyles = [
    "\x1B[31m",
    // Red
    "\x1B[32m",
    // Green
    "\x1B[33m",
    // Yellow
    "\x1B[34m",
    // Blue
    "\x1B[35m",
    // Magenta
    "\x1B[36m",
    // Cyan
    "\x1B[91m",
    // Bright Red
    "\x1B[92m",
    // Bright Green
    "\x1B[93m",
    // Bright Yellow
    "\x1B[94m",
    // Bright Blue
    "\x1B[95m",
    // Bright Magenta
    "\x1B[96m",
    // Bright Cyan
    "\x1B[1;31m",
    // Bold Red
    "\x1B[1;32m",
    // Bold Green
    "\x1B[1;33m",
    // Bold Yellow
    "\x1B[1;34m",
    // Bold Blue
    "\x1B[1;35m",
    // Bold Magenta
    "\x1B[1;36m",
    // Bold Cyan
    "\x1B[1;91m",
    // Bold Bright Red
    "\x1B[1;92m",
    // Bold Bright Green
    "\x1B[1;93m",
    // Bold Bright Yellow
    "\x1B[1;94m",
    // Bold Bright Blue
    "\x1B[1;95m",
    // Bold Bright Magenta
    "\x1B[1;96m"
    // Bold Bright Cyan
    // "\x1b[4;31m", // Underline Red
    // "\x1b[4;32m", // Underline Green
    // "\x1b[4;33m", // Underline Yellow
    // "\x1b[4;34m", // Underline Blue
    // "\x1b[4;35m", // Underline Magenta
    // "\x1b[4;36m", // Underline Cyan
    // "\x1b[4;91m", // Underline Bright Red
    // "\x1b[4;92m", // Underline Bright Green
    // "\x1b[4;93m", // Underline Bright Yellow
    // "\x1b[4;94m", // Underline Bright Blue
    // "\x1b[4;95m", // Underline Bright Magenta
    // "\x1b[4;96m", // Underline Bright Cyan
    // "\x1b[7;31m", // Reverse Red
    // "\x1b[7;32m", // Reverse Green
    // "\x1b[7;33m", // Reverse Yellow
    // "\x1b[7;34m", // Reverse Blue
    // "\x1b[7;35m", // Reverse Magenta
    // "\x1b[7;36m", // Reverse Cyan
    // "\x1b[7;91m", // Reverse Bright Red
    // "\x1b[7;92m", // Reverse Bright Green
    // "\x1b[7;93m", // Reverse Bright Yellow
    // "\x1b[7;94m", // Reverse Bright Blue
    // "\x1b[7;95m", // Reverse Bright Magenta
    // "\x1b[7;96m", // Reverse Bright Cyan
  ];
  const colorIndex = Math.abs(hash) % colorStyles.length;
  const selectedColor = colorStyles[colorIndex];
  const resetColor = "\x1B[0m";
  const s = `${selectedColor}[${jobId.substring(0, 6)}]${resetColor}`;
  jobColorCache.set(jobId, s);
  return s;
};
var queueColorCache = new import_lru_map.default(1e3);
var getQueueColorizedString = (queue) => {
  if (!queue) {
    return queue;
  }
  const cachedColor = queueColorCache.get(queue);
  if (cachedColor) {
    return cachedColor;
  }
  let hash = 0;
  for (let i = 0; i < queue.length; i++) {
    const char = queue.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  const colorStyles = [
    // "\x1b[31m", // Red
    // "\x1b[32m", // Green
    // "\x1b[33m", // Yellow
    // "\x1b[34m", // Blue
    // "\x1b[35m", // Magenta
    // "\x1b[36m", // Cyan
    // "\x1b[91m", // Bright Red
    // "\x1b[92m", // Bright Green
    // "\x1b[93m", // Bright Yellow
    // "\x1b[94m", // Bright Blue
    // "\x1b[95m", // Bright Magenta
    // "\x1b[96m", // Bright Cyan
    // "\x1b[1;31m", // Bold Red
    // "\x1b[1;32m", // Bold Green
    // "\x1b[1;33m", // Bold Yellow
    // "\x1b[1;34m", // Bold Blue
    // "\x1b[1;35m", // Bold Magenta
    // "\x1b[1;36m", // Bold Cyan
    // "\x1b[1;91m", // Bold Bright Red
    // "\x1b[1;92m", // Bold Bright Green
    // "\x1b[1;93m", // Bold Bright Yellow
    // "\x1b[1;94m", // Bold Bright Blue
    // "\x1b[1;95m", // Bold Bright Magenta
    // "\x1b[1;96m", // Bold Bright Cyan
    // "\x1b[4;31m", // Underline Red
    // "\x1b[4;32m", // Underline Green
    // "\x1b[4;33m", // Underline Yellow
    // "\x1b[4;34m", // Underline Blue
    // "\x1b[4;35m", // Underline Magenta
    // "\x1b[4;36m", // Underline Cyan
    // "\x1b[4;91m", // Underline Bright Red
    // "\x1b[4;92m", // Underline Bright Green
    // "\x1b[4;93m", // Underline Bright Yellow
    // "\x1b[4;94m", // Underline Bright Blue
    // "\x1b[4;95m", // Underline Bright Magenta
    // "\x1b[4;96m", // Underline Bright Cyan
    "\x1B[7;31m",
    // Reverse Red
    "\x1B[7;32m",
    // Reverse Green
    "\x1B[7;33m",
    // Reverse Yellow
    "\x1B[7;34m",
    // Reverse Blue
    "\x1B[7;35m",
    // Reverse Magenta
    "\x1B[7;36m",
    // Reverse Cyan
    "\x1B[7;91m",
    // Reverse Bright Red
    "\x1B[7;92m",
    // Reverse Bright Green
    "\x1B[7;93m",
    // Reverse Bright Yellow
    "\x1B[7;94m",
    // Reverse Bright Blue
    "\x1B[7;95m",
    // Reverse Bright Magenta
    "\x1B[7;96m"
    // Reverse Bright Cyan
  ];
  const colorIndex = Math.abs(hash) % colorStyles.length;
  const selectedColor = colorStyles[colorIndex];
  const resetColor = "\x1B[0m";
  const s = `${selectedColor}[[${queue.substring(0, 14)}]]${resetColor}`;
  queueColorCache.set(queue, s);
  return s;
};
var workerColorCache = new import_lru_map.default(1e3);
var getWorkerColorizedString = (worker) => {
  if (!worker) {
    return worker;
  }
  const cachedColor = workerColorCache.get(worker);
  if (cachedColor) {
    return cachedColor;
  }
  let hash = 0;
  for (let i = 0; i < worker.length; i++) {
    const char = worker.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash;
  }
  const colorStyles = [
    // "\x1b[31m", // Red
    // "\x1b[32m", // Green
    // "\x1b[33m", // Yellow
    // "\x1b[34m", // Blue
    // "\x1b[35m", // Magenta
    // "\x1b[36m", // Cyan
    // "\x1b[91m", // Bright Red
    // "\x1b[92m", // Bright Green
    // "\x1b[93m", // Bright Yellow
    // "\x1b[94m", // Bright Blue
    // "\x1b[95m", // Bright Magenta
    // "\x1b[96m", // Bright Cyan
    // "\x1b[1;31m", // Bold Red
    // "\x1b[1;32m", // Bold Green
    // "\x1b[1;33m", // Bold Yellow
    // "\x1b[1;34m", // Bold Blue
    // "\x1b[1;35m", // Bold Magenta
    // "\x1b[1;36m", // Bold Cyan
    // "\x1b[1;91m", // Bold Bright Red
    // "\x1b[1;92m", // Bold Bright Green
    // "\x1b[1;93m", // Bold Bright Yellow
    // "\x1b[1;94m", // Bold Bright Blue
    // "\x1b[1;95m", // Bold Bright Magenta
    // "\x1b[1;96m", // Bold Bright Cyan
    "\x1B[4;31m",
    // Underline Red
    "\x1B[4;32m",
    // Underline Green
    "\x1B[4;33m",
    // Underline Yellow
    "\x1B[4;34m",
    // Underline Blue
    "\x1B[4;35m",
    // Underline Magenta
    "\x1B[4;36m",
    // Underline Cyan
    "\x1B[4;91m",
    // Underline Bright Red
    "\x1B[4;92m",
    // Underline Bright Green
    "\x1B[4;93m",
    // Underline Bright Yellow
    "\x1B[4;94m",
    // Underline Bright Blue
    "\x1B[4;95m",
    // Underline Bright Magenta
    "\x1B[4;96m"
    // Underline Bright Cyan
    // "\x1b[7;31m", // Reverse Red
    // "\x1b[7;32m", // Reverse Green
    // "\x1b[7;33m", // Reverse Yellow
    // "\x1b[7;34m", // Reverse Blue
    // "\x1b[7;35m", // Reverse Magenta
    // "\x1b[7;36m", // Reverse Cyan
    // "\x1b[7;91m", // Reverse Bright Red
    // "\x1b[7;92m", // Reverse Bright Green
    // "\x1b[7;93m", // Reverse Bright Yellow
    // "\x1b[7;94m", // Reverse Bright Blue
    // "\x1b[7;95m", // Reverse Bright Magenta
    // "\x1b[7;96m", // Reverse Bright Cyan
  ];
  const colorIndex = Math.abs(hash) % colorStyles.length;
  const selectedColor = colorStyles[colorIndex];
  const resetColor = "\x1B[0m";
  const s = `${selectedColor}~~${worker.substring(0, 14)}~~${resetColor}`;
  workerColorCache.set(worker, s);
  return s;
};

// src/shared/base64.ts
function decodeBase64(b64) {
  const binString = atob(b64);
  const size = binString.length;
  const bytes = new Uint8Array(size);
  for (let i = 0; i < size; i++) {
    bytes[i] = binString.charCodeAt(i);
  }
  return bytes;
}
var encoder = new TextEncoder();

// src/shared/dataref.ts
var ENV_VAR_DATA_ITEM_LENGTH_MAX = 200;
var dataUrlToDataRef = (value) => {
  if (typeof value !== "string" || !value.startsWith("data:")) {
    return void 0;
  }
  const commaIndex = value.indexOf(",");
  if (commaIndex === -1) {
    return void 0;
  }
  const [mimeType, ...params] = value.substring("data:".length, commaIndex).split(";");
  const payload = value.substring(commaIndex + 1);
  if (mimeType === "text/x-uri") {
    return { type: "url" /* url */, value: decodeURIComponent(payload) };
  }
  if (params.includes("base64")) {
    return { type: "base64" /* base64 */, value: payload };
  }
  const text = payload ? decodeURIComponent(payload) : "";
  if (mimeType === "application/json") {
    try {
      return { type: "json" /* json */, value: JSON.parse(text) };
    } catch {
      return { type: "utf8" /* utf8 */, value: text };
    }
  }
  return { type: "utf8" /* utf8 */, value: text };
};
var dataRefToDownloadLink = async (ref) => {
  const buffer = await dataRefToBuffer(ref);
  return URL.createObjectURL(
    new Blob([buffer], { type: "application/octet-stream" })
  );
};
var dataRefToBuffer = async (ref, address) => {
  switch (ref.type) {
    case "base64" /* base64 */:
      return decodeBase64(ref.value);
    case "utf8" /* utf8 */:
      return new TextEncoder().encode(ref.value);
    case "json" /* json */:
      return new TextEncoder().encode(JSON.stringify(ref.value));
    case "url" /* url */: {
      try {
        const arrayBufferFromUrl = await urlToUint8Array(ref.value);
        return new Uint8Array(arrayBufferFromUrl);
      } catch (downloadError) {
        console.error(
          `Failed to download data from URL ${ref.value}:`,
          downloadError
        );
        throw downloadError;
      }
    }
    case "key" /* key */: {
      try {
        const arrayBufferFromKey = await fetchBlobFromHash(
          ref.value,
          address || "https://container.mtfm.io"
        );
        return new Uint8Array(arrayBufferFromKey);
      } catch (keyError) {
        console.error(
          `Failed to fetch blob from hash for key ${ref.value}:`,
          keyError
        );
        throw keyError;
      }
    }
    default:
      throw new Error(
        `Not yet implemented: DataRef.type "${ref.type}" unknown`
      );
  }
};
var AlreadyUploaded = {};
var copyLargeBlobsToCloud = async (inputs, address) => {
  if (!inputs || Object.keys(inputs).length === 0) {
    return;
  }
  const result = {};
  await Promise.all(
    Object.keys(inputs).map(async (name) => {
      const type = inputs[name]?.type || DataRefTypeDefault;
      let uint8ArrayIfBig;
      switch (type) {
        case "key" /* key */:
          break;
        case "url" /* url */:
          break;
        case "json" /* json */:
          if (inputs?.[name]?.value) {
            const jsonString = JSON.stringify(inputs[name].value);
            if (jsonString.length > ENV_VAR_DATA_ITEM_LENGTH_MAX) {
              uint8ArrayIfBig = utf8ToBuffer(jsonString);
            }
          }
          break;
        case "base64" /* base64 */:
          if (inputs?.[name]?.value.length > ENV_VAR_DATA_ITEM_LENGTH_MAX) {
            uint8ArrayIfBig = decodeBase64(inputs[name].value);
          }
          break;
        case "utf8" /* utf8 */:
          if (inputs?.[name]?.value?.length > ENV_VAR_DATA_ITEM_LENGTH_MAX) {
            uint8ArrayIfBig = utf8ToBuffer(inputs[name].value);
          }
          break;
        default:
      }
      if (uint8ArrayIfBig) {
        const hash = await sha256Buffer(uint8ArrayIfBig);
        const urlUpload = `${address}/f/${hash}`;
        if (!AlreadyUploaded[address]) {
          AlreadyUploaded[address] = {};
        }
        if (!AlreadyUploaded[address][hash]) {
          const responseUpload = await fetchRobust(urlUpload, {
            // @ts-ignore: TS2353
            method: "PUT",
            // @ts-ignore: TS2353
            redirect: "follow",
            body: uint8ArrayIfBig,
            headers: { "Content-Type": "application/octet-stream" }
          });
          if (!responseUpload.ok) {
            throw new Error(`Failed to get upload URL: ${urlUpload}`);
          }
          const ref = {
            value: `${address}/f/${hash}`,
            type: "url" /* url */,
            hash
          };
          result[name] = ref;
          AlreadyUploaded[address][hash] = true;
        } else {
          result[name] = {
            value: `${address}/f/${hash}`,
            type: "url" /* url */,
            hash
          };
        }
      } else {
        result[name] = inputs[name];
      }
    })
  );
  return result;
};
var convertJobOutputDataRefsToExpectedFormat = async (outputs, address) => {
  if (!outputs) {
    return;
  }
  let arrayBuffer;
  const newOutputs = {};
  await Promise.all(
    Object.keys(outputs).map(async (name) => {
      const type = outputs[name].type || DataRefTypeDefault;
      switch (type) {
        case "base64" /* base64 */: {
          const internalBlobRefFromBase64 = {
            _s: true,
            _c: "Blob",
            value: outputs[name].value,
            size: 0,
            fileType: void 0
            // TODO: can we figure this out?
          };
          newOutputs[name] = internalBlobRefFromBase64;
          break;
        }
        case "key" /* key */: {
          arrayBuffer = await fetchBlobFromHash(outputs[name].value, address);
          const internalBlobRefFromHash = {
            _c: Blob.name,
            _s: true,
            value: bufferToBase64(arrayBuffer),
            size: arrayBuffer.byteLength,
            fileType: void 0
            // TODO: can we figure this out?
          };
          newOutputs[name] = internalBlobRefFromHash;
          break;
        }
        case "json" /* json */:
          newOutputs[name] = outputs[name].value;
          break;
        case "url" /* url */: {
          arrayBuffer = await fetchBlobFromUrl(outputs[name].value);
          const internalBlobRefFromUrl = {
            _s: true,
            _c: Blob.name,
            value: bufferToBase64(arrayBuffer),
            fileType: void 0,
            // TODO: can we figure this out?
            size: arrayBuffer.byteLength
          };
          newOutputs[name] = internalBlobRefFromUrl;
          break;
        }
        case "utf8" /* utf8 */:
          newOutputs[name] = outputs[name].value;
          break;
      }
    })
  );
  return newOutputs;
};
var fetchBlobFromUrl = async (url) => {
  const response = await fetchRobust(url, {
    // @ts-ignore: TS2353
    method: "GET",
    // @ts-ignore: TS2353
    redirect: "follow",
    headers: { "Content-Type": "application/octet-stream" }
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch URL: ${url}`);
  }
  const arrayBuffer = await response.arrayBuffer();
  return arrayBuffer;
};
var fetchJsonFromUrl = async (url) => {
  const response = await fetchRobust(url, {
    // @ts-ignore: TS2353
    method: "GET",
    // @ts-ignore: TS2353
    redirect: "follow",
    headers: { "Content-Type": "application/json" }
  });
  const json = await response.json();
  return json;
};
var urlToUint8Array = async (url) => {
  const response = await fetchRobust(url, { redirect: "follow" });
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
  }
  const arrayBuffer = await response.arrayBuffer();
  return new Uint8Array(arrayBuffer);
};
var fetchBlobFromHash = (hash, address) => {
  return fetchBlobFromUrl(`${address}/f/${hash}`);
};
var _encoder = new TextEncoder();
var utf8ToBuffer = (str) => {
  return _encoder.encode(str);
};
var _decoder = new TextDecoder();
var bufferToUtf8 = (buffer) => {
  return _decoder.decode(buffer);
};
function bufferToBinaryString(buffer) {
  const base64Str = Array.prototype.map.call(buffer, function(ch) {
    return String.fromCharCode(ch);
  }).join("");
  return base64Str;
}
var bufferToBase64 = (buffer) => {
  const binstr = bufferToBinaryString(buffer);
  return btoa(binstr);
};
export {
  DataRefType,
  DataRefTypeDefault,
  DataRefTypesSet,
  DefaultNamespace,
  DockerJobFinishedReason,
  DockerJobState,
  ENV_VAR_DATA_ITEM_LENGTH_MAX,
  WebsocketMessageTypeClientToServer,
  WebsocketMessageTypeServerBroadcast,
  WebsocketMessageTypeWorkerToServer,
  bufferToBase64,
  bufferToBinaryString,
  bufferToUtf8,
  convertJobOutputDataRefsToExpectedFormat,
  copyLargeBlobsToCloud,
  dataRefToBuffer,
  dataRefToDownloadLink,
  dataUrlToDataRef,
  enqueuedToInMemoryDockerJob,
  fetchBlobFromHash,
  fetchJsonFromUrl,
  fetchRobust,
  formatDefinitionS3Key,
  formatResultsS3Key,
  getFinishedJobState,
  getJobColorizedString,
  getJobStateString,
  getQueueColorizedString,
  getWorkerColorizedString,
  isDataRef,
  isDockerJobDefinitionRowFinished,
  isFinalDockerJobFinishedReason,
  isFinishedStateWorthCaching,
  isJobCacheAllowedToBeDeleted,
  isJobDeletedOrRemoved,
  isJobOkForSending,
  isParentInjectedHashParamKey,
  resolveMostCorrectJob,
  sanitizeFilename,
  setJobStateFinished,
  setJobStateQueued,
  setJobStateReQueued,
  setJobStateRemoved,
  setJobStateRunning,
  sha256Buffer,
  shaDockerJob,
  shaObject,
  urlToUint8Array,
  utf8ToBuffer
};
//# sourceMappingURL=client.mjs.map
